const tr = {
  startStopAdmin: {
    nRecords1: "{{n}} kayıt",
    tNFields1: "{{n}} alan",
    totMapF1: "{{n}} bacağın yol mesafesi",
    tAttachTitle: "Ek evrak / fotoğraf",
    stStopped: "Tamamlandı",
    stStarted: "Başladı",
    stPending: "Beklemede",
    stMissing: "Beklemede · yapılmadı",
    allStatuses: "Tüm durumlar",
    allDepots: "Tüm depolar",
    allRoutes: "Tüm rotalar",
    allEmployees: "Tüm çalışanlar",
    clear: "Temizle",
    search: "Ara…",
    nRecords: "{{n}} kayıt",
    noRecords: "Kayıt yok",
    title: "Start-Stop Kayıtları",
    subtitle: "Satıra tıklayın: konumlar, harita, mesafeler ve fotoğraflar",
    kTotal: "Toplam tur",
    kMissing: "Zorunlu, yapılmadı",
    kTimeChanged: "Saati değişen",
    kOdometer: "Sayaç KM",
    timeChanged: "Saat değiştirilmiş",
    thEmployee: "Çalışan",
    thDate: "Tarih",
    thStatus: "Durum",
    thDuration: "Süre",
    details: "Ayrıntı",
    corrShort: "düz.",
    loadFailed: "Yüklenemedi",
    resetDone: "Kayıt sıfırlandı",
    resetFailed: "Sıfırlanamadı",
    dur: "{{h}}s {{m}}dk",
    yes: "Evet",
    no: "Hayır",
    lgStop: "Stop",
    lgRemaining: "Kalan stop",
    lgPackages: "Kalan paket",
    lgPickup: "Pickup",
    lgNote: "Not",
    startKm: "Başlangıç KM",
    endKm: "Bitiş KM",
    startTime: "Başlangıç saati",
    endTime: "Bitiş saati",
    pToday: "Bugün",
    pYesterday: "Dün",
    pLast7: "Son 7 gün",
    pThisWeek: "Bu hafta",
    pLastWeek: "Geçen hafta",
    pThisMonth: "Bu ay",
    pLastMonth: "Geçen ay",
    xDate: "Tarih",
    xEmployee: "Çalışan",
    xRoute: "Rota",
    xDepot: "Depo",
    xStatus: "Durum",
    xRequired: "Zorunlu",
    xStartTime: "Start saati",
    xStartSent: "Start gönderim",
    xStartKm: "Start KM",
    xStartAddr: "Start adres",
    xStartCoord: "Start koordinat",
    xStopTime: "Stop saati",
    xStopSent: "Stop gönderim",
    xStopKm: "Stop KM",
    xStopAddr: "Stop adres",
    xStopCoord: "Stop koordinat",
    xTotalKm: "Toplam KM",
    xDuration: "Süre (dk)",
    xCorrected: "Düzeltildi",
    noStart: "Start yapılmadı",
    noStop: "Stop yapılmadı",
    completeStop: "Stop'u tamamla",
    edit: "Düzelt",
    nextDay: "ertesi gün",
    byAdminCompleted: "Admin tarafından tamamlandı",
    byAdminEdited: "Admin düzeltti",
    sentAt: "Gönderim {{time}} ({{diff}} dk)",
    mapFailed: "Harita yüklenemedi",
    computing: "Mesafeler hesaplanıyor…",
    noCorrections: "Düzeltme yok",
    adminStopCompleted: "Admin · Stop tamamladı",
    reason: "Sebep",
    lat: "Enlem",
    lng: "Boylam",
    address: "Adres",
    corrected: "düzeltildi",
    nReminders: "{{n}} hatırlatma",
    kmOdo: "{{km}} km sayaç",
    windowClosed: "Stop süresi doldu ({{at}}). Sürücü artık Stop yapamaz; \"Stop'u tamamla\" ile kapatın.",
    secRoute: "Güzergâh ve mesafeler",
    secFiles: "Fotoğraf & evrak ({{n}})",
    none: "Yok",
    secCorrections: "Düzeltme geçmişi",
    noDepotLoc: "<b>{{depot}}</b> için konum girilmemiş. Planlama → Depolar'da depoyu düzenleyip konum ekleyin; Depo→Start ve Stop→Depo mesafeleri hesaplansın.",
    depot: "Depo",
    legDepotStart: "Depo → İlk Start",
    legOdo: "Start → Stop (araç sayacı)",
    legOdoSub: "Bitiş KM − Başlangıç KM",
    onMap: "haritada {{km}} km",
    legStopDepot: "Son Stop → Depo",
    road: "yol mesafesi",
    straight: "kuş uçuşu (yol bulunamadı)",
    aboutMin: "~{{m}} dk",
    totOdo: "Toplam (sayaç + uçlar)",
    totOdoF: "Depo→Start + sayaç + Stop→Depo",
    totOdoOnly: "sadece sayaç (depo konumu yok)",
    totMap: "Toplam (hepsi harita)",
    totMapF: "{{n}} bacağın yol mesafesi",
    mapLayer: "Harita / Uydu",
    satellite: "Uydu",
    map: "Harita",
    fullscreen: "Tam ekran",
    exitFullscreen: "Tam ekrandan çık",
    pinDepot: "DEPO",
    resetTitle: "Kaydı sıfırla",
    resetConfirmTitle: "Kayıt sıfırlansın mı?",
    resetConfirmBody: "Start-Stop kaydı, fotoğrafları ve düzeltmeleri silinecek; çalışan yeniden Start/Stop yapabilecek. Bu işlem geri alınamaz.",
    cancel: "Vazgeç",
    resetYes: "Evet, sıfırla",
    remBtn: "Hatırlatma",
    remTitle: "Start-Stop hatırlatmaları",
    remDesc: "Start ve Stop yapmayan sürücülere telefon bildirimi (push) gider.",
    remLoadFailed: "Ayarlar yüklenemedi",
    remSaved: "Hatırlatma ayarları kaydedildi",
    remInvalid: "Değerleri kontrol edin (saat 1–24, tekrar 15–360 dk)",
    saveFailed: "Kaydedilemedi",
    remEnabled: "Hatırlatma açık",
    remHours: "Start'tan kaç saat sonra",
    remHoursDesc: "Bu süre dolup Stop yoksa ilk bildirim gider",
    hours: "saat",
    min: "dk",
    remRepeat: "Bir kez daha hatırlat",
    remRepeatDesc: "Hâlâ Stop yoksa ikinci bildirim",
    remSecond: "İkinci hatırlatma",
    remSecondDesc: "İlkinden kaç dakika sonra",
    remAdmins: "Adminlere özet",
    remAdminsDesc: "Son hatırlatmadan sonra firma adminlerine Stop yapmayanların listesi gider",
    remEvery: "Kontrol her 5 dakikada bir yapılır.",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    locInvalid: "Konum \"enlem, boylam\" şeklinde olmalı",
    endTimeRequired: "Bitiş saati gerekli",
    reasonMin: "Sebep yazın (en az 3 karakter)",
    stopCompleted: "Stop tamamlandı",
    recordCorrected: "Kayıt düzeltildi",
    editTitleStart: "Start verilerini düzelt",
    editTitleStop: "Stop verilerini düzelt",
    editDesc: "Eski ve yeni değerler geçmişe yazılır.",
    locLabel: "Konum (enlem, boylam)",
    reasonLabel: "Sebep *",
    reasonPh: "örn. Sürücü Stop yapmayı unuttu, telefonla teyit edildi",
    complete: "Tamamla",
    tSsMode: "Start-Stop modu",
    tSsModeDesc: "Çalışanın panelinde büyük Start butonu çıkar; akşam Stop ile tur bitirilir. Formdaki hangi alanların Start'ta, hangilerinin Stop'ta sorulacağını aşağıdan seçin.",
    tRequired: "Zorunlu",
    tRequiredDesc: "Start/Stop yapılmadan form gönderilemez; yapmayanlar Start-Stop Kayıtları sayfasında kırmızı görünür.",
    tHideForm: "Formda kalan alanları gizle",
    tHideFormDesc: "İşaretli: sadece Start/Stop ekranları sorulur. İşaretsiz: 'Formda' kalan alanlar ayrıca form olarak doldurulur.",
    tHideRouteReport: "Eski \"Turu Bildir\" formunu gizle",
    tHideRouteReportDesc: "İşaretli: bu şablona planlanan şoförler panelde eski \"Turu Bildir\" butonunu görmez, sadece Start-Stop kullanır.",
    tWindow: "Start-Stop saat aralığı",
    tWindowStart: "Start açılış",
    tWindowEnd: "Stop son saati",
    tOvernight: "ertesi gün · gece turu",
    tClear: "temizle",
    tWindowSet: "Sürücü atama günü {{ws}}'dan {{nd}}{{we}}'a kadar Start/Stop yapabilir. Süre dolunca açık kalan turu admin tamamlar.",
    tNextDayPrefix: "ertesi gün ",
    tWindowEmpty: "Boş: atama günü 00:00–24:00 arası. Gece turları için örn. 20:00 → 10:00 girin (bitiş küçükse ertesi gün sayılır).",
    pFillDepot: "Depo koordinatını yaz",
    pUsesDepot: "Boş bırakılırsa depo koordinatı kullanılır ({{c}})",
    pOpenMap: "Haritada aç",
    pPointLabelPh: "Örn: Müşteri deposu Genk",
    pPointLabel: "Konum adı (sürücüye gösterilir)",
    pCoordsInvalid: "Geçersiz format. Örnek: 51.17452,5.82870",
    pCoords: "Başlangıç koordinatı (enlem,boylam)",
    simToStart: "Depodan Start'a gidiyor",
    simTour: "Turda (dağıtım)",
    simBack: "Depoya dönüyor",
    simAtDepot: "Depoya döndü",
    simReset: "Başa sar",
    nMin: "{{m}} dk",
    departDepot: "Depodan çıkış",
    returnDepot: "Depoya dönüş",
    workTotal: "Toplam çalışma",
    workFormula: "Depodan çıkış (Start − depo→Start yol süresi) → depoya dönüş (Stop + Stop→depo yol süresi)",
    workEstimated: "Yol süreleri kısmen tahmini (yol servisi yanıt vermedi)",
    workNoDepot: "Depo koordinatı yok — sadece Start→Stop süresi",
    nfStart: "Start hatırlatması",
    nfClose: "Stop son saat: {{m}} dk kala",
    nfOverdue: "Geciken Stop hatırlatması",
    noNotifs: "Henüz bildirim gönderilmedi",
    secNotifs: "Bildirim geçmişi ({{n}})",
    workShort: "Toplam {{d}}",
    thWork: "Toplam çalışma",
    kWork: "Toplam çalışma",
    kWorkAvg: "Ort. {{d}} · {{n}} tur",
    kWorkNone: "Tamamlanan tur yok",
    pTitle: "Sabit başlama saati ve konumu",
    pDesc: "Çalışan sadece KM girip Start'a basar; saat ve konum buradan gelir, değiştiremez.",
    pDefaultTime: "Depo varsayılan saati",
    pDefaultTimeCompany: "Varsayılan saat",
    pRouteTimes: "Tura göre başlama saati",
    pUsesDefault: "varsayılan {{time}}",
    pFree: "serbest",
    pLocation: "Sabit başlangıç konumu (örn. müşteri deposu)",
    pLocationDesc: "Start kaydına bu konum yazılır; telefon konumu yedek/log olarak saklanır. Konum alınamasa da Start yapılabilir.",
    pNoCoords: "Koordinat girilmedi ve deponun koordinatı yok — telefon konumu kullanılır.",
    pHint: "Saat boş bırakılan turlarda çalışan saati kendisi girer. Start penceresi boyunca 5 kez, Stop son saatine 60/30/10 dk kala bildirim gider.",
    presetTimeBadge: "Sabit saat · tıklama {{time}}",
    presetLocBadge: "Sabit başlangıç konumu",
    deviceLoc: "Telefon konumu (yedek)",
    deviceLocNone: "Telefon konumu alınamadı",
    remStartPrompts: "Start hatırlatması (5 kez)",
    remStartPromptsDesc: "Start yapılmadıysa pencere açılışından başlama saatine kadar eşit aralıklarla",
    remClose: "Stop son saat hatırlatması",
    remCloseDesc: "Stop yapılmadıysa son saate 60, 30 ve 10 dk kala",
    tAskStart: "Start'ta sorulacak",
    tAskStop: "Stop'ta sorulacak",
    tNFields: "{{n}} alan",
    tAutoLoc: "Konum ve saat her zaman otomatik alınır",
    tNoFields: "Henüz alan yok",
    tUnnamed: "(adsız)",
    tKmPhoto: "KM + foto",
    tKmPhotoTitle: "Çalışan KM'yi yazar; yanında isteğe bağlı gösterge fotoğrafı çekebilir",
    tRemoveFromPhase: "Bu aşamadan çıkar (forma geri döner)",
    tAttachMulti: "(çoklu)",
    tShow: "Göster",
    tAddKm: "{{label}} ekle (yaz veya foto)",
    tPickExisting: "+ Mevcut form alanından seç…",
    tNewField: "Yeni alan ekle",
    tFieldNamePh: "Alan adı (örn. Stop sayısı)",
    tAdd: "Ekle",
    tAllFields: "Tüm form alanları — nerede sorulsun?",
    tInForm: "Formda",
    tTimeLocked: "Saat Start/Stop ekranında otomatik alınır",
    tHint: "Bir alan tek yerde sorulur. Start'a/Stop'a taşınan KM alanında çalışan KM'yi yazar, yanında isteğe bağlı gösterge fotoğrafı çekebilir. Saat alanları taşınamaz; Start/Stop saati kendisi alır.",
    tAtStart: "Start'ta",
    tAtStop: "Stop'ta",
    ty_text: "Metin",
    ty_number: "Sayı",
    ty_time: "Saat",
    ty_date: "Tarih",
    ty_photo: "Foto",
    ty_boolean: "Evet/Hayır",
    ty_select: "Seçim",
  },
  startStop: {
    todayBadge: "BUGÜN",
    tomorrowBadge: "YARIN",
    afterStop: "Stop sonrası",
    overnight: "Dünkü gece turu · Stop son saati {{time}}",
    overnightBadge: "DÜN GECE",
    startOpensAt: "Start {{time}}'da açılır",
    stopDeadline: "Stop son saati {{time}}",
    nextDay: "(ertesi gün)",
    windowClosed: "Start-Stop süresi doldu",
    closedManagerCompletes: "Turunuzu yöneticiniz tamamlayacak.",
    closedInformManager: "Yöneticinize bilgi verin.",
    startTour: "Turu başlat",
    required: "zorunlu",
    running: "Tur devam ediyor",
    startLabel: "Başlangıç",
    startKmShort: "Başl. KM",
    photo: "foto",
    finished: "Tur tamamlandı",
    correctionUsed: "Düzeltme hakkı kullanıldı",
    correctLast: "Son verileri düzelt (1 hak)",
    elapsed: "{{h}} sa {{m}} dk",
    yes: "Evet",
    no: "Hayır",
    saveFailed: "Kaydedilemedi",
    optional: "(isteğe bağlı)",
    noLocStart: "Konum bilgisi olmadan başlatılamaz",
    noLocStop: "Konum bilgisi olmadan bitirilemez",
    orPhoto: "(veya foto)",
    missing: "Eksik: {{list}}",
    startKm: "Başlangıç KM",
    endKm: "Bitiş KM",
    startTime: "Başlangıç saati",
    endTime: "Bitiş saati",
    timeHint: "Değiştirirseniz gönderim saati de ayrıca kaydedilir",
    kmHintStart: "Yazın veya sağdaki kamera ile göstergenin fotoğrafını çekin",
    kmHintStop: "Yazın veya kamera ile göstergenin fotoğrafını çekin",
    startedTitle: "Tur başladı",
    goodWork: "İyi çalışmalar!",
    canClose: "Ekranı kapatabilirsiniz. Tur bitince buradan STOP deyin.",
    startTitle: "Turu Başlat",
    takePhoto: "Foto çek",
    addFile: "Dosya ekle",
    attachments: "Ek evrak",
    attachmentsPhotos: "Ek evrak / fotoğraf",
    endKmLess: "Bitiş KM, başlangıçtan ({{km}}) küçük olamaz",
    filesUploading: "Dosyalar yükleniyor, bekleyin",
    savedThanks: "Operasyon kaydedildi, teşekkürler!",
    totalKm: "Toplam {{km}} km",
    recordReceived: "Kayıt alındı",
    oneCorrection: "Hatalı bir şey girdiyseniz 1 kez düzeltme hakkınız var.",
    stopTitle: "Turu Bitir",
    stopSave: "STOP · Kaydet",
    reasonRequired: "Düzeltme sebebini yazın",
    noChange: "Değişiklik yok",
    correctionSaved: "Düzeltme kaydedildi",
    correctTitle: "Son verileri düzelt",
    correctSubtitle: "Tek düzeltme hakkınız var, kayıt altına alınır",
    saveCorrection: "Düzeltmeyi kaydet",
    correctionReason: "Düzeltme sebebi *",
    reasonPlaceholder: "ör. KM yanlış yazıldı",
    okClose: "Tamam, ekranı kapat",
    geoUnsupported: "Cihazınız konum desteklemiyor",
    geoDenied: "Konum izni reddedildi. Tarayıcı ayarlarından bu siteye konum izni verin ve tekrar deneyin.",
    geoFailed: "Konum alınamadı. Açık alanda tekrar deneyin.",
    geoOk: "Konum alındı",
    presetLocation: "Başlangıç konumu: {{depot}} (ayarlı)",
    presetTimeHint: "Başlama saati yönetici tarafından ayarlandı",
    refresh: "Yenile",
    geoRetry: "Konumu tekrar dene",
    geoLoading: "Konum alınıyor… izin isterse \"İzin ver\" deyin",
    kmPhotoUploaded: "KM fotoğrafı yüklendi",
    photoUploadFailed: "Fotoğraf yüklenemedi",
    kmPlaceholder: "ör. 125430",
    kmPhotoTitle: "KM fotoğrafı çek",
    now: "Şimdi",
    photoAdded: "Fotoğraf eklendi · değiştir",
    takePhotoFull: "Fotoğraf çek",
    geoModalTitle: "Konumunuz alınamadı",
    geoWaiting: "Konum bekleniyor…",
    geoRequired: "Konum olmadan Start / Stop gönderilemez.",
    gettingLocation: "Konum alınıyor…",
    retry: "Tekrar dene",
    close: "Kapat",
    overdueTitle: "Stop yapmayı unuttunuz mu?",
    overdueBody: "Turunuz {{h}} saattir açık. Bitirdiyseniz hemen Stop'a basın.",
    stepsDeniedIos: ["Ayarlar → Gizlilik → Konum Servisleri açık olsun", "Ayarlar → Safari (veya uygulama) → Konum → \"Sor\" veya \"İzin Ver\"", "Bu sayfaya dönüp \"Tekrar dene\"ye basın"],
    stepsDeniedAndroid: ["Adres çubuğundaki kilit simgesine dokunun", "İzinler → Konum → \"İzin ver\"", "Telefonun konumu (GPS) açık olsun, sonra \"Tekrar dene\""],
    stepsOther: ["Telefonun konumu (GPS) açık olsun", "Bina içindeyseniz açık alana çıkın", "\"Tekrar dene\"ye basın"],
  },
  common: {
    welcome: "Hoş Geldiniz",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    logout: "Çıkış",
    dashboard: "Kontrol Paneli",
    profile: "Profil",
    settings: "Ayarlar",
    security: "Güvenlik",
    users: "Kullanıcılar",
    firms: "Firmalar",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    create: "Oluştur",
    yes: "Evet",
    no: "Hayır",
    clear: "Temizle",
    clearAll: "Temizle",
    optional: "opsiyonel",
    approve: "Onayla",
    reject: "Reddet",
    pending: "Beklemede",
    active: "Aktif",
    rejected: "Reddedildi",
    search: "Ara",
    year: "Yıl",
    month: "Ay",
    day: "Gün",
    unknown: "Bilinmiyor",
    firmDistribution: "Firma Dağılımı",
    loading: "Yükleniyor...",
    error: "Hata",
    success: "Başarılı",
    back: "Geri",
    next: "Sonraki",
    previous: "Önceki",
    submit: "Gönder",
    actions: "İşlemler",
    noData: "Veri bulunamadı",
    confirmDelete: "Silmek istediğinizden emin misiniz?",
    auditLogs: "Denetim Kayıtları",
    leaveRequests: "İzin Talepleri",
    confirm: "Onayla",
    confirmation: "Onay",
    all: "Tümü",
    firm: "Firma",
    refresh: "Yenile",
    total: "toplam",
    email: "E-posta Adresi",
    language: "Dil",
    filter: "Filtre",
    clearFilter: "Filtreyi Temizle",
    close: "Kapat",
    noResults: "Sonuç bulunamadı",
    globalSearch: "Kullanıcı veya plaka ara...",
    filters: "Filtreler",
    clearFilters: "Temizle",
    more: "daha fazla",
    refreshed: "Yenilendi",
    show: "Göster",
    perPage: "kayıt",
    showing: "Gösterilen",
    page: "Sayfa",
    collapseMenu: "Menüyü Daralt",
    expandMenu: "Menüyü Genişlet",
    darkMode: "Karanlık Mod",
    lightMode: "Aydınlık Mod",
    colorTheme: "Renk Teması",
    minutes: "dk",
    selectAll: "Tümünü Seç",
    deselectAll: "Tümünü Kaldır",
    vehicleBadge: "Araç",
    unassigned: "Atanmamış",
    from: "Başlangıç",
    to: "Bitiş",
    name: "Ad",
    status: "Durum",
    type: "Tür",
    date: "Tarih",
    amount: "Tutar",
    description: "Açıklama",
    details: "Detaylar",
    view: "Görüntüle",
    download: "İndir",
    upload: "Yükle",
    add: "Ekle",
    remove: "Kaldır",
    select: "Seç",
    selected: "Seçildi",
    none: "Yok",
    lastMonth: "Geçen Ay",
    period: "Dönem",
    dateRange: "Tarih Aralığı",
    records: "kayıt",
    allFirms: "Tüm Firmalar",
    selectFirm: "Firma seçin",
    accessDenied: "Erişim Engellendi",
    document: "Belge",
    inactive: "Pasif",
    processing: "İşleniyor...",
    saving: "Kaydediliyor...",
    sending: "Gönderiliyor...",
    allDepos: "Tüm Depolar",
    noDepo: "Deposuz",
    reset: "Sıfırla",
    showSold: "Satılanları göster",
    sold: "SATILDI",
    saleDate: "Satış Tarihi",
    saleDateHint: "Satış tarihi girilirse araç satılmış sayılır ve listelerde görünmez",
    inVehicle: "Araç içinde",
    outVehicle: "Araç dışında",
    purchaseDate: "Aankoopdatum",
    saved: "Kaydedildi",
    addNote: "Not Ekle",
    addNoteFor: "{name} için not ekleyin (sadece yöneticiler görebilir)",
    noFilterResults: "Seçilen filtreler için çalışan bulunamadı",
    startDate: "Başlangıç",
    endDate: "Bitiş",
  },
  imageCropper: {
    title: "Resim Düzenle",
    dragDrop: "Resmi sürükleyip bırakın",
    or: "veya",
    selectFile: "Dosya Seç",
    paste: "Yapıştır",
    pasteHint: "Ctrl+V ile panodan yapıştırabilirsiniz",
    changeImage: "Resmi Değiştir",
    zoom: "Yakınlaştır",
    rotate: "Döndür",
    preview: "Önizleme",
    reset: "Sıfırla",
    upload: "Yükle",
  },
  documentEditor: {
    dragDropTitle: "Belgeyi sürükleyip bırakın",
    supportedFormats: "JPG, PNG, WEBP, PDF desteklenir",
    selectFile: "Dosya Seç",
    pasteFromClipboard: "Panodan Yapıştır",
    pasteHint: "Ctrl+V ile panodan direkt yapıştırabilirsiniz",
    rotateLeft: "Sola Döndür",
    rotateRight: "Sağa Döndür",
    flipHorizontal: "Yatay Çevir",
    flipVertical: "Dikey Çevir",
    reset: "Sıfırla",
    changeImage: "Farklı Resim Seç",
    skipEdit: "Düzenlemeden Yükle",
    cropAndUpload: "Kes ve Yükle",
    deleteConfirm: "Bu belgeyi silmek istediğinizden emin misiniz?",
    deleteDocument: "Belgeyi Sil",
    deleteSuccess: "Belge silindi",
    processing: "İşleniyor...",
    save: "Kaydet",
    saveAndUpload: "Kaydet ve Yükle",
  },
  nav: {
    lockedDates: "Kilitli Tarihler",
    mailArchive: "Mail Arşivi",
    frontendSettings: "Görünüm Ayarları",
    siteSettings: "Site Ayarları",
    myDocuments: "Dosyalarım",
    myPayslips: "Bodrolarım",
    myPackages: "Paketlerim",
    myFinance: "Finansal Verilerim",
    personalMenu: "Kişisel",
    myNotifications: "Bildirimlerim",
    documentManagement: "Doküman Yönetimi",
    docManagement: "Dokümanlar",
    loonbrief: "Bordro Yükleme",
    loonbriefList: "Bordro Listesi",
    pdfUpload: "PDF Yükle",
    sendNotification: "Bildirim Gönder",
    routes: "Routelar",
    allRoutes: "Tüm Routelar",
    routeReports: "Route Raporları",
    fuelReports: "Yakıt Raporu",
    vehicles: "Araçlarım",
    allUsers: "Tüm Kullanıcılar",
    languages: "Diller",
    databaseBackup: "Veritabanı Yedekleme",
    postnlCodes: "PostNL Kodları",
    planning: "Planlama",
    messages: "Mesajlar",
    chat: "Sohbet",
    todoList: "Yapılacaklar",
    communication: "İletişim",
    dpd: "DPD",
    dpdDailySummary: "DPD Günlük Özet",
    dpdDriverPerformance: "DPD Şoför Performansı",
    dpdConsolidated: "DPD Konsolide Rapor",
    dpdMonthlyInvoice: "DPD Aylık Fatura",
    dpdRetourHeatmap: "DPD Retour Isı Haritası",
    dpdSubcoComparison: "DPD Subco Karşılaştırma",
    dpdCourierMapping: "DPD Kurye Eşleştirme",
    dpdRetourReport: "DPD Retour Raporu",
    dpdFileCategories: "DPD Dosya Kategorileri",
    dpdAnalytics: "DPD Analitik & İçgörü",
  },
  fields: {
    firm_id: "Firma Seçimi",
    date: "Tarih",
    route_number: "Route Numarası",
    route_type: "Tur Tipi",
    rit: "Rit",
    vehicle_plate: "Araç Plakası",
    driver: "Şoför",
    copilot: "Yardımcı Şoför (Copilot)",
    km_start: "KM Başlangıç",
    km_end: "KM Bitiş",
    stops: "Stops (Durak Sayısı)",
    stop_price: "Stop Prijs (Durak Fiyatı)",
    hourly_rate: "Saat Ücreti (€)",
    start_cost: "Başlangıç Maliyeti (€)",
    start_time: "Başlangıç Saati",
    end_time: "Bitiş Saati",
    break_time: "Mola Süresi",
    totaal_excl_btw: "Totaal excl BTW",
  },
  calcTypes: {
    hours_rate: "Saat × Ücret + Başlangıç Maliyeti",
    stops_price: "Stops × Stop Fiyatı",
    fixed_rate: "Sabit Ücret + Başlangıç Maliyeti",
    manual_total: "Başlangıç Maliyeti = Toplam",
  },
  fuelReports: {
    title: "Dagrapport Brandstof",
    subtitle: "Yakıt Raporu",
    date: "Tarih",
    plate: "Plaka",
    tankCard: "Tank Kart",
    driver: "Şoför",
    liters: "Litre",
    pricePerLiter: "€/Litre",
    total: "Toplam",
    period: "Periyot",
    totalRecords: "Kayıt",
    totalLiters: "Toplam Litre",
    totalCost: "Toplam Maliyet",
    searchPlaceholder: "Şoför, plaka veya tank kart ara...",
    add: "Yeni Yakıt Kaydı",
    edit: "Yakıt Kaydı Düzenle",
    importTitle: "Excel Dosyasından Aktar",
    startDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    notes: "Notlar",
    attachments: "Dosya Ekleri",
    loadError: "Veriler yüklenemedi",
    dateAndPlateRequired: "Tarih ve plaka zorunludur",
    updated: "Güncellendi",
    added: "Eklendi",
    errorOccurred: "Hata oluştu",
    operationFailed: "İşlem başarısız",
    deleted: "Silindi",
    cannotDelete: "Silinemedi",
    fileAndFirmRequired: "Dosya ve firma seçimi zorunludur",
    importSuccess: "{{count}} kayıt aktarıldı",
    importFailed: "Aktarım başarısız",
    fileUploaded: "Dosya yüklendi",
    uploadFailed: "Yükleme başarısız",
    fileDeleted: "Dosya silindi",
    fileTooLarge: "10MB'dan büyük olamaz",
    fileUploadFailed: "yüklenemedi",
    excelImport: "Excel Aktar",
    selectDriver: "Şoför seçin",
    searchDriver: "Şoför ara ve seç...",
    selectFirmFirst: "Önce firma seçin",
    searchDriverPlaceholder: "Şoför ara...",
    driverNotFound: "Şoför bulunamadı",
    manualEntry: "veya manuel girin",
    servicePartner: "Service Partner",
    clone: "Klonla",
    cloned: "Kayıt kopyalandı - güncel tarihle",
    noRecords: "Kayıt bulunamadı",
    deleteConfirm: "Bu kaydı silmek istediğinize emin misiniz?",
    matched: "Eşleştirildi",
    selectPlate: "Plaka seçin",
    searchPlate: "Plaka ara...",
    plateNotFound: "Plaka bulunamadı",
    addFile: "Dosya ekle",
    noAttachments: "Dosya eki yok",
    importing: "Aktarılıyor...",
    import: "Aktar",
    manualDriverEntry: "veya şoför adı girin",
    dragDropFiles: "Dosyaları sürükleyin veya tıklayın",
    delete: "Sil",
  },
  loonbrief: {
    title: "Bordro Yükleme",
    description: "Bordro PDF'lerini otomatik olarak çalışanlara dağıtın",
    uploadSettings: "Yükleme Ayarları",
    firm: "Firma",
    firmRequired: "Firma *",
    selectFirm: "Firma seçin...",
    period: "Dönem",
    periodRequired: "Dönem *",
    selectPeriod: "Dönem seçin...",
    pdfUpload: "PDF Yükle",
    selectFirmFirst: "Lütfen önce bir firma seçin",
    selectPeriodFirst: "Lütfen dönem seçin",
    processing: "PDF işleniyor, lütfen bekleyin...",
    processSuccess: "PDF işlendi",
    processError: "PDF işlenirken hata oluştu",
    matched: "eşleşti",
    unmatched: "eşleşmedi",
    results: "İşlem Sonuçları",
    page: "Sayfa",
    nameFromPdf: "PDF'deki İsim",
    matchedEmployee: "Eşleşen Çalışan",
    status: "Durum",
    action: "İşlem",
    statusMatched: "Eşleşti",
    statusUnmatched: "Eşleşmedi",
    statusError: "Hata",
    manualMatch: "Elle Eşleştir",
    manualMatchTitle: "Elle Eşleştir",
    nameInPdf: "PDF'deki isim:",
    searchEmployee: "Çalışan ara...",
    employeeNotFound: "Çalışan bulunamadı",
    matchSuccess: "ile eşleştirildi",
    aliases: "Lakaplar",
    naam: "Naam",
    clear: "Temizle",
    saveMatched: "Eşleşenleri Kaydet",
    noMatchedToSave: "Kayıt edilecek eşleşmiş bordro yok",
    pdfNotFound: "PDF dosyası bulunamadı, lütfen tekrar yükleyin",
    saveSuccess: "bordro başarıyla kaydedildi",
    savePartialError: "bordro kaydedilemedi",
    saveError: "Kayıt sırasında hata oluştu",
    employeesLoaded: "çalışan yüklendi",
    employeesWithAliases: "çalışanın lakabı tanımlı",
    cancel: "İptal",
    saveSummaryTitle: "Kaydetme Sonucu",
    saveSummaryDesc: "Bordro kaydetme işlemi tamamlandı.",
    summarySaved: "Kaydedildi",
    summaryErrors: "Hata",
    summaryUnmatched: "Eşleşmedi",
    summarySuccessTitle: "Başarıyla Kaydedilen Bordrolar",
    summaryErrorTitle: "Hatalı Kayıtlar",
    summaryUnmatchedTitle: "Eşleştirilemeyenler",
    summaryUpdated: "Güncellendi",
    unmatchedHint: "Bu çalışanlar sisteme kayıtlı olmayabilir veya isimleri farklı formatta olabilir. Elle eşleştirme yapabilirsiniz.",
    close: "Kapat",
  },
  languages: {
    subtitle: "Sistem çevirilerini düzenleyin",
    syncComplete: "Senkronizasyon tamamlandı!",
    syncCompleteDesc: "{added} yeni eklendi, {updated} güncellendi, {skipped} atlandı",
    syncFailed: "Senkronizasyon başarısız",
    translationSaved: "Çeviri veritabanına kaydedildi",
    translationSaveFailed: "Çeviri kaydedilemedi",
    keyNameRequired: "Anahtar adı zorunludur",
    keyAlreadyExists: "Bu anahtar zaten mevcut",
    atLeastOneValue: "En az bir çeviri değeri girmelisiniz",
    newKeyAdded: "Yeni çeviri anahtarı eklendi",
    addKeyFailed: "Çeviri eklenemedi",
    exported: "Çeviriler dışa aktarıldı",
    invalidFileFormat: "Geçersiz dosya formatı. JSON dosyası {tr: {...}, en: {...}, ...} yapısında olmalı",
    analysisFailed: "Dosya analizi başarısız",
    invalidJson: "Geçersiz JSON dosyası",
    importComplete: "İçe aktarma tamamlandı!",
    importCompleteDesc: "{added} yeni, {updated} güncellenen, {skipped} atlanan",
    importFailed: "İçe aktarma başarısız",
    cacheCleared: "Önbellek temizlendi, varsayılan çevirilere dönüldü",
    translationsTab: "Çeviriler",
    scanTab: "Eksik Tespit",
    scanTitle: "Eksik Çeviri Anahtarı Tespiti",
    scanDescription: "Kaynak kodda kullanılan ama tanımlanmayan çeviri anahtarlarını ve diller arası eksiklikleri tespit eder.",
    scanBtn: "Taramayı Başlat",
    scanning: "Taranıyor...",
    scanComplete: "Tarama tamamlandı",
    scanFailed: "Tarama başarısız",
    scanKeysScanned: "Kodda Taranan",
    scanKeysDefined: "i18n Tanımlı",
    scanUndefined: "Tanımsız Anahtar",
    scanCrossLang: "Diller Arası Eksik",
    scanSearchPlaceholder: "Anahtar ara...",
    allLanguages: "Tüm Diller",
    undefinedInCode: "Kodda Kullanılıp Tanımlanmayan Anahtarlar",
    undefinedInCodeDesc: "Bu anahtarlar kaynak kodda t() ile çağrılıyor ancak hiçbir dilde tanımlı değil.",
    crossLangMissing: "Diller Arası Eksik Anahtarlar",
    crossLangMissingDesc: "Bu anahtarlar bazı dillerde tanımlı ama diğerlerinde eksik.",
    missingInLangs: "Eksik Diller",
    presentInLangs: "Mevcut Diller",
    allKeysComplete: "Tüm Anahtarlar Tamamlandı!",
    allKeysCompleteDesc: "Kodda kullanılan tüm çeviri anahtarları tüm dillerde tanımlı.",
    scanPrompt: "Eksik çeviri anahtarlarını tespit etmek için tarama başlatın",
    scanPromptDesc: "Kaynak kod dosyaları taranarak kullanılan anahtarlar i18n tanımları ile karşılaştırılacaktır.",
    scanningInProgress: "Kaynak kodlar taranıyor...",
    synced: "Senkron",
    syncToDb: "DB'ye Aktar",
    newKey: "Yeni Anahtar",
    export: "Dışa Aktar",
    analyzing: "Analiz...",
    import: "İçe Aktar",
    reset: "Sıfırla",
    missing: "eksik",
    complete: "Tamam",
    filteringMissing: "Eksik çeviriler filtreleniyor...",
    searchPlaceholder: "Anahtar veya değer ara...",
    selectNamespace: "Namespace seç",
    allNamespaces: "Tüm Namespace",
    perPageSuffix: "/ sayfa",
    allMissing: "Tüm Eksikler",
    clearFilter: "Filtreyi Temizle",
    translationsTitle: "Çeviriler",
    translationsFound: "çeviri bulundu",
    missingFor: "eksikleri",
    allMissingLabel: "Tüm eksikler",
    keyColumn: "Anahtar",
    actionColumn: "İşlem",
    missingValue: "(eksik)",
    noResults: "Sonuç bulunamadı",
    pageLabel: "Sayfa",
    editTitle: "Çeviri Düzenle",
    missingBadge: "Eksik",
    translationPlaceholder: "çevirisi...",
    cancel: "İptal",
    saving: "Kaydediliyor...",
    save: "Kaydet",
    addTitle: "Yeni Çeviri Anahtarı Ekle",
    addDescription: "Anahtar formatı: namespace.key (örn: common.newFeature)",
    keyName: "Anahtar Adı",
    keyPlaceholder: "örn: common.addFinancialRecord",
    translationValues: "Çeviri Değerleri",
    adding: "Ekleniyor...",
    add: "Ekle",
    importPreviewTitle: "İçe Aktarma Önizlemesi",
    importPreviewDesc: "Dosya analiz edildi. Aşağıdaki değişiklikler yapılacak:",
    willAdd: "Yeni Eklenecek",
    willUpdate: "Güncellenecek",
    totalKeys: "Toplam Anahtar",
    importMode: "İçe Aktarma Modu:",
    modeMerge: "Birleştir (Önerilen)",
    modeSkip: "Var Olanları Atla",
    modeOverwrite: "Üzerine Yaz",
    modeMergeDesc: "Mevcut değerler korunur, yeni değerler eklenir/güncellenir",
    modeSkipDesc: "Sadece yeni anahtarlar eklenir, mevcutlar değişmez",
    modeOverwriteDesc: "Tüm değerler dosyadaki ile değiştirilir",
    keysAlreadyExist: "anahtar zaten mevcut",
    keysAlreadyExistDesc: "Bu anahtarların değerleri güncellenecek.",
    protectExisting: "modunu seçerek mevcut değerleri koruyabilirsiniz.",
    newKeysToAdd: "Yeni Eklenecek Anahtarlar",
    andMoreKeys: "... ve {count} anahtar daha",
    keysToUpdate: "Güncellenecek Anahtarlar",
    existingToNew: "Mevcut → Yeni değerler",
    importing: "İçe Aktarılıyor...",
    syncTitle: "Çevirileri Veritabanına Aktar",
    syncDesc: "i18n.js dosyasındaki tüm çevirileri MongoDB veritabanına aktarın. Bu işlem sadece eksik anahtarları ekler, mevcut düzenlemelerinizi korur.",
    inI18n: "i18n.js'de",
    inDb: "DB'de Mevcut",
    toBeAdded: "Eklenecek",
    whatDoesThisDo: "Bu işlem ne yapar?",
    syncInfo1: "i18n.js dosyasındaki tüm çevirileri okur",
    syncInfo2: "DB'de olmayan anahtarları ekler",
    syncInfo3: "Zaten mevcut olanları KORUR (ezmez)",
    syncInfo4: "Artık DB tek kaynak olur (Single Source of Truth)",
    dbSynced: "Veritabanı senkronize!",
    dbSyncedDesc: "{synced} i18n'den, {added} kullanıcı tarafından eklendi",
    dbNotSynced: "Veritabanı henüz senkronize değil",
    dbNotSyncedDesc: "İlk kurulum için \"Senkronize Et\" butonuna basın",
    syncing: "Senkronize Ediliyor...",
    syncBtn: "Senkronize Et",
  },
  documents: {
    myDocuments: "Dosyalarım",
    myDocumentsDesc: "Şirket sözleşmeleri ve kişisel evraklarınız",
    management: "Doküman Yönetimi",
    managementDesc: "Şirket belgelerini ve çalışan evraklarını yönetin",
    all: "Tümü",
    companyDocs: "Şirket Belgeleri",
    personalDocs: "Kişisel Evraklar",
    company: "Şirket",
    personal: "Kişisel",
    noDocuments: "Henüz belge yok",
    noDocumentsDesc: "Size atanmış dosya bulunmuyor",
    noDocumentsAdminDesc: "Henüz belge yüklenmemiş",
    fetchError: "Dosyalar yüklenemedi",
    uploadError: "Dosya yüklenemedi",
    downloadError: "Dosya indirilemedi",
    downloadSuccess: "Dosya indiriliyor",
    previewError: "Önizleme açılamadı",
    updateSuccess: "Dosya güncellendi",
    updateError: "Dosya güncellenemedi",
    deleteSuccess: "Dosya silindi",
    deleteError: "Dosya silinemedi",
    deleteConfirm: "Dosyayı Sil",
    upload: "Dosya Yükle",
    uploadFiles: "Dosyaları Yükle",
    uploadDesc: "Dosya yükleyin veya sürükleyip bırakın",
    uploadFirst: "Önce dosya yükleyin",
    files: "Dosyalar",
    fileName: "Dosya Adı",
    category: "Kategori",
    assignedTo: "Atanan",
    assignTo: "Atama Yap",
    assignToAll: "Tüm çalışanlara ata",
    searchUsers: "Kullanıcı ara",
    searchPlaceholder: "Dosya ara...",
    size: "Boyut",
    uploadedAt: "Yüklenme Tarihi",
    preview: "Görüntüle",
    download: "İndir",
    editDocument: "Belgeyi Düzenle",
    invalidFileType: "Bazı dosyalar desteklenmeyen formatta",
    targetFirm: "Hedef Firma",
    allCompanies: "Global (Tüm Firmalar)",
    globalDocNote: "Bu belge tüm firmalar için geçerlidir",
    firm: "Firma",
    pdfLoadError: "PDF yüklenemedi",
    pdfCorruptOrInvalid: "PDF bozuk veya geçersiz",
    downloadInstead: "Bunun yerine indir",
    previewNotSupported: "Bu dosya türü önizlenemiyor",
    noPreview: "Önizleme mevcut değil",
    showing: "Gösterilen",
    of: "/",
    items: "öğe",
    perPage: "Sayfa başına",
    deleteMessage: "Bu dosyayı silmek istediğinizden emin misiniz?",
    dragDrop: "Dosyaları sürükleyip bırakın",
    employee: "Çalışan",
    fileUploaded: "Dosya yüklendi",
    firmDocuments: "Firma Belgeleri",
    firmDocumentsDesc: "Şirket genelinde paylaşılan belgeler",
    or: "veya",
    selectEmployee: "Çalışan Seç",
    selectFile: "Dosya Seç",
    totalDocuments: "Toplam Belge",
    uploadDate: "Yükleme Tarihi",
    uploadDocument: "Belge Yükle",
    uploadDocumentDesc: "Dosya yükleyin veya sürükleyip bırakın",
    visibility: "Görünürlük",
    visibleToEmployee: "Çalışana Görünür",
    filterByFirm: "Firma Filtrele",
    uploadSuccess: "Dosya yüklendi",
    originalName: "Orijinal",
    allDocuments: "Tüm Belgeler",
    assignedDocuments: "Atanmış Belgeler",
    assignedToMe: "Bana Atananlar",
    companyDocuments: "Firma Belgeleri",
    dateRange: "Tarih Aralığı",
    documentName: "Belge Adı",
    documentType: "Belge Türü",
    fileSize: "Dosya Boyutu",
    filterByType: "Türe Göre Filtrele",
    noResults: "Belge bulunamadı",
    private: "Özel",
    public: "Herkese Açık",
    uploadedBy: "Yükleyen",
  },
  packages: {
    title: "Paketler",
    subtitle: "Fatura ve dağıtım verileri",
    fetchError: "Paketler yüklenirken hata oluştu",
    statsError: "İstatistikler yüklenirken hata oluştu",
    detailError: "Fatura detayı yüklenirken hata oluştu",
    totalInvoices: "Toplam",
    totalAmount: "Toplam Tutar",
    totalEmployees: "Çalışan Sayısı",
    totalRegions: "Bölge Sayısı",
    overview: "Genel Bakış",
    invoices: "Fatura",
    employees: "Çalışanlar",
    regions: "Bölgeler",
    weeklyTrend: "Haftalık Trend",
    regionDistribution: "Bölge Dağılımı",
    topEmployees: "En Yüksek Kazançlı Çalışanlar",
    topEmployeesByPackage: "En Çok Paket Dağıtan Çalışanlar",
    invoiceList: "Fatura Listesi",
    invoiceNumber: "Fatura No",
    invoiceDate: "Fatura Tarihi",
    weekNumber: "Hafta",
    company: "Firma",
    location: "Lokasyon",
    employeeStats: "Çalışan İstatistikleri",
    employeeName: "Çalışan",
    totalQuantity: "Toplam Adet",
    routeDays: "Çalışılan Gün/Route",
    workDays: "Çalışma Günü",
    dailyAverage: "Günlük Ortalama",
    difference: "Fark (165)",
    bonusCalculation: "Bonus Hesaplama",
    unitPrice: "Birim Fiyat",
    calculation: "Hesaplama",
    dayShort: "gün",
    clickToCopy: "Kopyalamak için tıklayın",
    copiedToClipboard: "kopyalandı",
    totalEarnings: "Toplam Kazanç",
    regionStats: "Bölge İstatistikleri",
    region: "Bölge",
    searchInvoice: "Fatura no ara...",
    amount: "Tutar",
    createdAt: "Oluşturma Tarihi",
    employeeCount: "Çalışan Sayısı",
    invoiceDetail: "Fatura Detayı",
    year: "Yıl",
    week: "Hafta",
    date: "Tarih",
    quantity: "Adet",
    total: "Toplam",
    searchEmployee: "Çalışan ara...",
    noEmployeeFound: "ile eşleşen çalışan bulunamadı",
    employeesShown: "çalışan gösteriliyor",
    allCompanies: "Tüm Firmalar",
    allLocations: "Tüm Lokasyonlar",
    noInvoiceFound: "Filtreye uygun fatura bulunamadı",
    invoicesShown: "fatura gösteriliyor",
    deleteConfirmTitle: "Faturayı Sil",
    deleteConfirmMessage: "numaralı faturayı ve tüm ilişkili verileri (çalışanlar, bölgeler) silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    deleteSuccess: "Fatura başarıyla silindi",
    deleteError: "Fatura silinirken hata oluştu",
    allRegions: "Tüm Bölgeler",
    allDates: "Tüm Tarihler",
    unitPrice: "Birim Fiyat",
    fixedCharge: "Sabit",
    filteredQuantity: "Filtrelenen Adet",
    filteredTotal: "Filtrelenen Toplam",
    regionSummary: "Bölge Özeti",
    selected: "seçili",
    deleteSelected: "Seçilenleri Sil",
    bulkDeleteTitle: "Toplu Fatura Silme",
    bulkDeleteConfirmMessage: "adet faturayı ve tüm ilişkili verileri (çalışanlar, bölgeler) silmek istediğinize emin misiniz?",
    bulkDeleteWarning: "Bu işlem geri alınamaz!",
    selectedInvoices: "Silinecek Faturalar",
    deleteAll: "Tümünü Sil",
    invoicesDeleted: "fatura başarıyla silindi",
    invoicesDeleteError: "fatura silinirken hata oluştu",
    showingInvoices: "Gösterilen",
    perPage: "Sayfa başına",
    page: "Sayfa",
    allWeeks: "Tüm Haftalar",
    selectWeeks: "Hafta Seçin",
    selectMonth: "Ay Seçin",
    monthsSelected: "ay seçili",
    yearlyComparison: "Yıllık",
    yearlyQuantity: "Yıllık Paket Adetleri",
    weeklyYearComparison: "Haftalık Karşılaştırma",
    packageCount: "Paket",
    amountPerPackage: "Paket Başına Ortalama Tutar",
    driverLocationMatrix: "Şoför-Lokasyon Performans Matrisi",
    driverLocationMatrixDesc: "Her şoförün hangi lokasyonda ne kadar performans gösterdiğini görün",
    driver: "Şoför",
    locationTotal: "Lokasyon Toplamı",
    showingTopDrivers: "En yüksek performanslı",
    drivers: "şoför gösteriliyor",
    matrixError: "Performans matrisi yüklenirken hata oluştu",
    last7Days: "Son 7 Gün",
    last4Weeks: "Son 4 Hafta",
    last3Months: "Son 3 Ay",
    allTime: "Tüm Zamanlar",
    seasonalTrends: "Sezonsal Trend Analizi",
    seasonalInsights: "Sezonsal İçgörüler",
    monthly: "Aylık",
    quarterly: "Çeyreklik",
    yearOverYearGrowth: "Yıllık Büyüme",
    busiestByAmount: "En Yoğun (Tutar)",
    busiestByPackage: "En Yoğun (Paket)",
    monthlyPattern: "Aylık Desen",
    avgQuantity: "Ort. Paket",
    seasonalError: "Sezonsal trend analizi yüklenirken hata oluştu",
    last6MonthsVs: "Son 6 Ay vs Önceki",
    last12MonthsVs: "Son 12 Ay vs Önceki",
    periodGrowth: "Dönem Karşılaştırması",
    totalAmountLabel: "Toplam Tutar",
    totalPackageLabel: "Toplam Paket",
    amountPerPackageLabel: "Paket Başına Tutar",
    changePercent: "Değişim (%)",
    weekLabel: "Hafta",
    dateRange: "Tarih Aralığı",
    dateRangeFilter: "Tarih Aralığı ile Filtrele",
    startDate: "Başlangıç",
    endDate: "Bitiş",
    clearSelection: "Temizle",
    weeksSelected: "hafta seçili",
    last3Years: "Son 3 Yıl",
    last4Years: "Son 4 Yıl",
  },
  employeeProfile: {
    title: "Çalışan Profilleri",
    myProfile: "Profilim",
    personalInfo: "Kişisel Bilgiler",
    documents: "Belgeler",
    history: "İzin & Çalışma Geçmişi",
    finance: "Finans & İstatistik",
    profileCompletion: "Profil Tamamlama",
    complete: "Tamamlandı",
    incomplete: "Eksik",
    saveProfile: "Kaydet",
    uploadDocument: "Belge Yükle",
    addFinanceEntry: "Finansal Kayıt Ekle",
    type: "Tür",
    aliases: "Lakaplar / İkincil İsimler",
    aliasesDescription: "Bordro PDF eşleştirmesi için kullanılır. Örn: GEMALMAZ HUSAMETTIN, H.GEMALMAZ",
    addAliasPlaceholder: "Yeni lakap ekle...",
    profilePhoto: "Profil Fotoğrafı",
    changePhoto: "Fotoğrafı Değiştir",
    uploadPhoto: "Fotoğraf Yükle",
    photoUploaded: "Profil fotoğrafı yüklendi",
    photoUploadError: "Fotoğraf yüklenemedi",
    uploadCover: "Kapak Fotoğrafı Yükle",
    coverUploaded: "Kapak fotoğrafı yüklendi",
    coverUploadError: "Kapak fotoğrafı yüklenemedi",
    addJobTitle: "+ Rol / Unvan ekle",
    jobTitlePlaceholder: "Rol / Unvan (örn. Süper Admin)",
    addBio: "+ Kısa biyografi ekle",
    bioPlaceholder: "Kısa biyografi (maks. 280 karakter)",
    upload: "Yükle",
    preview: "Önizleme",
    download: "İndir",
    openInNewTab: "Yeni Sekmede Aç",
    downloadError: "İndirme hatası",
    importantDocuments: "Önemli Belgeler",
    importantDocumentsDesc: "Kimlik, Sürücü Belgesi ve Ehliyet belgeleriniz",
    frontSide: "Ön Yüz",
    backSide: "Arka Yüz",
    showFrontSide: "Ön yüzü göster",
    showBackSide: "Arka yüzü göster",
    identityCard: "Kimlik Kartı",
    identityCardDesc: "TC Kimlik veya Nüfus Cüzdanı",
    passport: "Pasaport",
    passportDesc: "Geçerli pasaport belgesi",
    driverLicense: "Ehliyet",
    driverLicenseDesc: "Sürücü belgesi",
    uploaded: "Yüklendi",
    notUploaded: "Yüklenmedi",
    myDocuments: "Belgelerim",
    employeeDocuments: "Çalışan Belgeleri",
    documentsOf: "Belgeleri",
    otherDocuments: "Diğer Belgeler",
    firstName: "Ad",
    lastName: "Soyad",
    birthDate: "Doğum Tarihi",
    birthPlace: "Doğum Yeri",
    nationality: "Uyruk",
    nationalId: "Kimlik Numarası",
    maritalStatus: "Medeni Durum",
    bloodType: "Kan Grubu",
    idExpiryDate: "Kimlik Son Kullanma Tarihi",
    licenseExpiryDate: "Ehliyet Son Kullanma Tarihi",
    ocrHint: "Belge yüklerken otomatik doldurulur",
    ocrProcessing: "Belge taranıyor, tarihler çıkarılıyor...",
    ocrExpiryFound: "Son kullanma tarihi bulundu",
    ocrDatesFound: "Tarihler bulundu",
    ocrNoDateFound: "Belgede tarih bulunamadı. Lütfen manuel girin.",
    ocrError: "OCR tarama hatası",
    documentEditor: {
      dragDropTitle: "Belgeyi sürükleyip bırakın",
      supportedFormats: "JPG, PNG, WEBP, PDF desteklenir",
      selectFile: "Dosya Seç",
      pasteFromClipboard: "Panodan Yapıştır",
      pasteHint: "Ctrl+V ile panodan direkt yapıştırabilirsiniz",
      rotateLeft: "Sola Döndür",
      rotateRight: "Sağa Döndür",
      flipHorizontal: "Yatay Çevir",
      flipVertical: "Dikey Çevir",
      reset: "Sıfırla",
      changeImage: "Farklı Resim Seç",
      skipEdit: "Düzenlemeden Yükle",
      cropAndUpload: "Kes ve Yükle",
      applyChanges: "Değişiklikleri Uygula",
      cancel: "İptal",
      crop: "Kırp",
      edit: "Düzenle",
      editing: "Düzenleniyor",
      readyToUpload: "Yüklemeye Hazır",
      rotate: "Döndür",
      zoom: "Yakınlaştır",
      zoomIn: "Yakınlaştır",
      zoomOut: "Uzaklaştır",
      deleteConfirm: "Bu belgeyi silmek istediğinizden emin misiniz?",
      deleteDocument: "Belgeyi Sil",
      deleteSuccess: "Belge başarıyla silindi",
      processing: "İşleniyor...",
      save: "Kaydet",
      saveAndUpload: "Kaydet ve Yükle",
    },
    expiringDocuments: "Süresi Yaklaşan Belgeler",
    expiringDocumentsDesc: "Belge son kullanma tarihleri yaklaşan çalışanlar",
    daysRemaining: "gün kaldı",
    expired: "Süresi Doldu",
    noExpiringDocuments: "Süresi yaklaşan belge yok",
    cropAndEdit: "Kes ve Yükle",
    ocrResults: "OCR Tarama Sonuçları",
    ocrResultsDesc: "Belgeden aşağıdaki tarihler çıkarıldı. Onaylarsanız forma uygulanacak.",
    applyDates: "Tarihleri Uygula",
    employmentDates: "İş Tarihleri",
    employmentStartDate: "İşe Başlama Tarihi",
    employmentEndDate: "İşten Ayrılma Tarihi",
    employmentDatesUpdated: "İş tarihleri güncellendi",
    employmentDatesError: "İş tarihleri güncellenemedi",
    single: "Bekar",
    married: "Evli",
    divorced: "Boşanmış",
    widowed: "Dul",
    cohabiting: "Birlikte Yaşıyor",
    addressInfo: "Adres Bilgileri",
    street: "Sokak/Cadde",
    houseNumber: "Kapı No",
    postalCode: "Posta Kodu",
    city: "Şehir",
    country: "Ülke",
    contactBankInfo: "İletişim & Banka Bilgileri",
    phone: "Telefon",
    emailAddress: "E-posta Adresi",
    bankAccount: "Banka Hesabı (IBAN)",
    fiscalInfo: "Vergi Durumu",
    fiscalInfoDesc: "Vergi indirimi hakkı olan kişileri belirtin",
    childrenDependent: "Bakmakla yükümlü çocuk",
    numberOfChildren: "Çocuk sayısı",
    spouseDependent: "Bakmakla yükümlü eş",
    otherDependents: "Diğer bakmakla yükümlü kişiler",
    numberOfOtherDependents: "Kişi sayısı",
    noDocuments: "Henüz belge yok",
    noDocumentsDesc: "Yöneticiniz size belge atayabilir",
    firstUpload: "İlk belgeyi yükle",
    documentType: "Belge Türü",
    documentNumber: "Belge Numarası",
    issueDate: "Düzenlenme Tarihi",
    expiryDate: "Geçerlilik Tarihi",
    notes: "Notlar",
    selectFile: "Dosya seçin",
    dragDrop: "Tıklayın veya dosyayı sürükleyin",
    dragDropMultiple: "Dosyaları sürükleyip bırakın",
    orClickToSelect: "veya seçmek için tıklayın",
    clickToAddMore: "Daha fazla dosya eklemek için tıklayın veya sürükleyin",
    filesSelected: "dosya seçildi",
    documentsUploaded: "belge yüklendi",
    invalidFileType: "Bazı dosyalar desteklenmeyen formatta",
    forUpload: "için belge yükle",
    dropFilesHere: "Dosyaları buraya bırakın",
    filesWillBeUploaded: "Dosyalar yüklenecek",
    dragDropHint: "İpucu: Dosyaları bu alana sürükleyip bırakarak hızlıca yükleyebilirsiniz",
    fileTypes: "PDF, JPG, PNG, DOC (maks 10MB)",
    deleteDocumentTitle: "Belgeyi Sil",
    deleteDocumentConfirm: "Bu belgeyi silmek istediğinizden emin misiniz?",
    deleteDocumentWarning: "Bu işlem geri alınamaz.",
    documentDeleted: "Belge silindi",
    documentDeleteError: "Belge silinemedi",
    editDocument: "Belgeyi Düzenle",
    documentUpdated: "Belge güncellendi",
    documentUpdateError: "Belge güncellenemedi",
    categoryHint: "Belgenin kategorisini seçin",
    currentCategory: "Mevcut Kategori",
    uploadedBy: "Yükleyen",
    date: "Tarih",
    idCard: "Kimlik Kartı",
    residencePermit: "Oturma İzni",
    workContract: "İş Sözleşmesi",
    diploma: "Diploma/Sertifika",
    medicalCert: "Sağlık Raporu",
    bankDetails: "Banka Bilgileri",
    taxForm: "Vergi Belgesi",
    other: "Diğer",
    approved: "Onaylanan",
    pending: "Bekleyen",
    leaveDays: "İzin Günleri",
    workDays: "Çalışma Günleri",
    recentLeaves: "Son İzin Talepleri",
    approvedDates: "Onaylanan Tarihler",
    noLeaves: "İzin talebi yok",
    totalDebt: "Toplam Borç",
    totalPaid: "Toplam Ödenen",
    bonus: "Prim/Bonus",
    netBalance: "Net Bakiye",
    transactionHistory: "İşlem Geçmişi",
    noTransactions: "İşlem yok",
    financeHidden: "Finansal bilgiler yönetici tarafından gizlendi",
    advance: "Avans",
    debt: "Borç",
    payment: "Ödeme",
    deduction: "Kesinti",
    bonusType: "Prim",
    potPlus: "POT+ (Alacak)",
    potMinus: "POT- (Borç)",
    laadvergoeding: "Laadvergoeding (Elektrik)",
    leasing: "Leasing",
    otherType: "Diğer",
    clickForDetails: "Detaylar için tıklayın",
    details: "Detayları",
    noPotEntries: "POT kaydı bulunmuyor",
    addNew: "Yeni Ekle",
    amount: "Tutar",
    description: "Açıklama",
    deleteRecord: "Kaydı Sil",
    deleteConfirm: "Bu kaydı silmek istediğinizden emin misiniz?",
    employeesFound: "çalışan bulundu",
    searchPlaceholder: "İsim veya e-posta ara...",
    allProfiles: "Tüm Profiller",
    completeProfiles: "Tamamlanmış",
    incompleteProfiles: "Eksik",
    allFirms: "Tüm Firmalar",
    avgCompletion: "Ort. Tamamlama",
    noEmployees: "Çalışan bulunamadı",
    exportCsv: "CSV İndir",
    employee: "Çalışan",
    contact: "İletişim",
    profile: "Profil",
    profileSaved: "Profil kaydedildi",
    profileSaveError: "Profil kaydedilemedi",
    documentUploaded: "Belge yüklendi",
    documentUploadError: "Belge yüklenemedi",
    documentSideUploaded: "yüklendi",
    unsupportedFileFormat: "Desteklenmeyen dosya formatı. JPG, PNG, PDF veya HEIC yükleyin.",
    loadError: "Yükleme hatası",
    payslipsDesc: "Aylık bordro dökümanlarınız",
    noPayslips: "Henüz bordro yüklenmemiş",
    noPayslipsDesc: "Bordro dökümanlarınız yüklendiğinde burada görüntülenecektir",
    packagesDesc: "Paket dağıtım verileriniz",
    noPackages: "Paket verisi bulunamadı",
    noPackagesDesc: "Paket dağıtım verileri yüklendiğinde burada görüntülenecektir",
    category: "Kategori",
    personal: "Kişisel",
    company: "Şirket",
    back: "Geri",
    uploadBtn: "Yükle",
    cancelBtn: "İptal",
    deleteBtn: "Sil",
    completeProfileTitle: "Profilinizi Tamamlayın",
    completeProfileDesc: "Devam etmeden önce lütfen profil bilgilerinizi doldurun.",
    goToProfile: "Profile Git",
    selectFileAndType: "Lütfen dosya ve belge türü seçin",
    requiredFields: "Zorunlu alanları doldurun",
    addNote: "Not Ekle",
    addNoteDesc: "Bu çalışan hakkında özel not ekleyin (sadece yöneticiler görebilir)",
    notePlaceholder: "Notunuzu buraya yazın...",
    notesList: "Notlar",
    noNotes: "Henüz not eklenmemiş",
    packagesTab: "Paketler",
    today: "Bugün",
    yesterday: "Dün",
    thisWeek: "Bu Hafta",
    thisMonth: "Bu Ay",
    thisYear: "Bu Yıl",
    allRegions: "Tüm Bölgeler",
    totalPackages: "Toplam Paket",
    workedDays: "Çalışılan Gün",
    dailyAvg: "Günlük Ort.",
    region: "Bölge",
    totalAmount: "Toplam Tutar",
    dailyPackageDist: "Günlük Paket Dağılımı",
    last30DaysPackages: "Son 30 günün paket sayısı",
    regionDist: "Bölge Dağılımı",
    regionDistDesc: "Paketlerin bölgelere göre dağılımı",
    packageCount: "adet",
    packageLabel: "Paket",
    amountLabel: "Tutar",
    loonbriefsTab: "Bodrolar",
    loonbriefsTitle: "Bodrolar",
    loonbriefsDesc: "için yüklenmiş bordro dökümanları",
    uploadedOn: "tarihinde yüklendi",
    viewBtn: "Görüntüle",
    downloadBtn: "İndir",
    noLoonbriefs: "Henüz bordro yüklenmemiş",
    noLoonbriefsDesc: "Bordro Yükleme sayfasından bu çalışana bordro yükleyebilirsiniz",
    allYears: "Tüm Yıllar",
    selectMonth: "Ay Seç",
    period: "Dönem",
    viewProfile: "Profil Görüntüle",
    applyOcrData: "Verileri Uygula",
    ocrAllDatesHint: "Bulunan diğer tarihler (tıklayarak seçin):",
    ocrResultsEditableDesc: "OCR taramasından bulunan tarihler aşağıda gösterilmektedir. Yanlışsa düzeltebilir veya manuel girebilirsiniz.",
    aliasesSaved: "Lakaplar kaydedildi",
    aliasesTab: "Lakaplar",
    financeTab: "Finans",
    financeTitle: "Finansal Kayıtlar",
    manualEntry: "Manuel Giriş",
    noAliases: "Henüz lakap tanımlanmamış",
    noFinanceRecords: "Finansal kayıt yok",
    ocrDetectedDates: "OCR Tespit Edilen Tarihler",
    ocrNoResults: "Tarih tespit edilemedi",
    removeAlias: "Lakabı kaldır",
    saveAliases: "Lakapları Kaydet",
    showAdvancedSection: "Gelişmiş Göster",
    totalAdvance: "Toplam Avans",
    totalRecords: "Toplam Kayıt",
  },
  employeeTracking: {
    title: "Çalışan Takibi",
    description: "Çalışanların günlük durumlarını takip edin",
    filter: "Filtre",
    searchEmployee: "Çalışan ara...",
    noResults: "Sonuç bulunamadı",
    clearFilter: "Filtreyi Temizle",
    employee: "Çalışan",
    employees: "Çalışan",
    all: "Tümü",
    selectFirm: "Firma seçin",
    daySummary: "Gün Özeti",
    totalWorking: "Toplam Çalışma",
    totalLeave: "Toplam İzin",
    totalSick: "Toplam Hasta",
    totalDop: "Toplam DOP",
    noEmployeeFound: "Aktif çalışan bulunmuyor",
    noFilterMatch: "Seçilen filtre kriterlerine uygun çalışan bulunamadı",
    firmsLoadError: "Firmalar yüklenemedi",
    dataLoadError: "Veriler yüklenemedi",
    status: {
      working: "Çalıştı",
      halfDay: "Yarım Gün",
      sick: "Hasta",
      dop: "DOP",
      onLeave: "İzinli",
      holiday: "Tatil Günü",
      halfSick: "Yarım Hasta",
      saturday: "Cumartesi",
      paternity: "Babalık İzni",
      unknown: "Belirsiz",
    },
    months: {
      january: "Ocak",
      february: "Şubat",
      march: "Mart",
      april: "Nisan",
      may: "Mayıs",
      june: "Haziran",
      july: "Temmuz",
      august: "Ağustos",
      september: "Eylül",
      october: "Ekim",
      november: "Kasım",
      december: "Aralık",
    },
    days: {
      sun: "Paz",
      mon: "Pzt",
      tue: "Sal",
      wed: "Çar",
      thu: "Per",
      fri: "Cum",
      sat: "Cmt",
    },
    globalSearch: "Kullanıcı veya plaka ara...",
  },
  routes: {
    title: "Routelar / Turlar",
    description: "Günlük route ve tur verilerini yönetin",
    allRoutes: "Route Listesi",
    newRoute: "Yeni Route",
    editRoute: "Route Düzenle",
    addRoute: "Yeni Route Ekle",
    importExcel: "Excel Yükle",
    exportExcel: "Excel İndir",
    recalculate: "Yeniden Hesapla",
    recalculateTitle: "Tüm Route'ları Yeniden Hesapla",
    recalculateBody: "Mevcut tüm route kayıtlarının çalışma saati ve toplam tutarları güncel hesaplama kurallarıyla yeniden hesaplanacak. Sabit ücret 0 gibi eski hatalı kayıtlar düzeltilecek. Bu işlem geri alınamaz.",
    customer: "Müşteri",
    customers: "Müşteriler",
    multiSelect: "Çoklu seçim",
    firm: "Firma",
    allFirms: "Tüm Firmalar",
    month: "Ay",
    allMonths: "Tüm Aylar",
    selectMonths: "Ay Seçin",
    search: "Ara",
    searchPlaceholder: "Şoför, plaka...",
    date: "Tarih",
    licensePlate: "Plaka",
    driver: "Şoför",
    copilot: "Yardımcı",
    routeNumber: "Route No",
    routeType: "Tur Tipi",
    ritNumber: "Rit No",
    rit: "Rit",
    tour: "Tur",
    routeRitTour: "Route/Rit/Tur",
    place: "Yer",
    startTime: "Başlangıç",
    endTime: "Bitiş",
    breakTime: "Mola",
    workHours: "Çalışma Saati",
    hourlyRate: "Saat Ücreti",
    startCost: "Başlangıç Ücreti",
    workCost: "Çalışma Ücreti",
    totalCost: "Toplam",
    kmStart: "Başlangıç KM",
    kmEnd: "Bitiş KM",
    kmTotal: "Toplam KM",
    km: "KM",
    time: "Saat",
    price: "Ücret",
    total: "Toplam",
    actions: "İşlemler",
    edit: "Düzenle",
    delete: "Sil",
    save: "Kaydet",
    cancel: "İptal",
    close: "Kapat",
    selectAll: "Tümünü Seç",
    deleteSelected: "Seçilenleri Sil",
    confirmDelete: "Bu kaydı silmek istediğinizden emin misiniz?",
    confirmBulkDelete: "Seçili {count} kaydı silmek istediğinizden emin misiniz?",
    noRecords: "Bu ay için kayıt bulunamadı",
    addFirstRecord: "İlk Kaydı Ekle",
    records: "kayıt",
    deleteRecords: "Kayıt Sil",
    selectRow: "Satır seç",
    selectAllOnPage: "Bu sayfadakileri seç",
    perPage: "Sayfa başına",
    firstPage: "İlk sayfa",
    previousPage: "Önceki sayfa",
    nextPage: "Sonraki sayfa",
    lastPage: "Son sayfa",
    editAllFields: "Tüm alanları düzenle",
    copyWithToday: "Kopyala (Bugünün tarihi ile)",
    copyRecords: "kayıt kopyala",
    exportFiltered: "Filtrelenmiş veriyi dışa aktar",
    viewAttachments: "Dosya Ekleri",
    summary: {
      totalRecords: "Toplam Kayıt",
      totalHours: "Toplam Saat",
      totalKm: "Toplam KM",
      totalAmount: "Toplam Tutar",
      perRecord: "kayıt başına ort.",
    },
    import: {
      title: "Excel'den İçe Aktar",
      multiSheetSupport: "Çoklu Sayfa Desteği",
      customerType: "Müşteri Tipi",
      pleaseSelectCustomer: "Lütfen bir müşteri tipi seçin",
      columnMapping: "Seçilen müşteri tipine göre Excel sütunları eşleştirilecek",
      firmLabel: "Firma:",
      selectFirm: "Firma seçin",
      required: "Zorunlu",
      dragDropFile: "Dosyayı sürükleyip bırakın veya tıklayın",
      dropFileHere: "Dosyayı buraya bırakın...",
      fileFormats: "CSV veya Excel (.xlsx) • Birden fazla sayfa desteklenir",
      selectFile: "Dosya Seçin",
      unsupportedFormat: "Desteklenmeyen dosya formatı. Lütfen .xlsx, .xls veya .csv dosyası seçin.",
      excelLoaded: "Excel yüklendi",
      sheetsCount: "sayfa",
      totalRows: "toplam satır",
      rowsRead: "satır okundu",
      fileReadError: "Dosya okunamadı",
      sheetSelection: "Sayfa Seçimi",
      sheetsSelected: "sayfa seçili",
      rows: "satır",
      selectDeselectAll: "Tümünü Seç / Kaldır",
      noData: "Veri yok",
      preview: "Önizleme",
      toImport: "İçe Aktarılacak",
      sheet: "sayfa",
      selectedSheets: "Seçili sayfalar",
      moverColumns: "Mover Excel Sütunları:",
      fedexColumns: "FedEx Excel Sütunları:",
      expressColumns: "Express Excel Sütunları:",
      getaxColumns: "GeTax Excel Sütunları:",
      optionalFields: "Opsiyonel",
      defaultRate: "varsayılan",
      startCost: "Start kost",
      notes: "Opmerkingen",
      selectCustomerType: "Müşteri Tipi Seçin",
      importRecords: "Kayıt İçe Aktar",
      importSheets: "Sayfa",
      noDataToImport: "İçe aktarılacak veri yok",
      andMore: "ve",
      moreRows: "satır daha (bu sayfada)",
      duplicateWarning: "mükerrer kayıt atlandı",
      selectSheet: "Sayfa Seçin",
      selectCustomer: "Müşteri Tipi Seçin",
      customerRequired: "Lütfen önce müşteri tipi seçin",
      dragDrop: "Sürükle-bırak veya tıkla",
      rowsFound: "satır bulundu",
      import: "İçe Aktar",
      importing: "İçe aktarılıyor...",
      success: "kayıt başarıyla içe aktarıldı",
      duplicatesSkipped: "mükerrer kayıt atlandı",
      error: "İçe aktarma hatası",
      moreRecords: "kayıt daha",
    },
    form: {
      selectDate: "Tarih seçin",
      selectDriver: "Şoför seçin",
      selectCopilot: "Yardımcı seçin",
      selectVehicle: "Araç seçin",
      manualEntry: "Manuel giriş",
      searchEmployee: "Çalışan ara...",
      noEmployeeFound: "Çalışan bulunamadı",
      calculation: "Hesaplama",
      searchDriver: "Şoför ara...",
      searchCopilot: "Yardımcı şoför ara...",
      driverNotFound: "Şoför bulunamadı",
      loading: "Yükleniyor...",
      customerRequired: "Müşteri *",
      customerCannotChange: "Düzenleme sırasında müşteri değiştirilemez",
      firmRequired: "Firma *",
      selectFirm: "Firma seçin",
      dateRequired: "Tarih *",
      routeNumberLabel: "Route Numarası",
      routeNumberPlaceholder: "Örn: 741",
      tourTypeRequired: "Tur Tipi *",
      selectTour: "Tur seçin",
      tourTypePlaceholder: "Tur tipi girin...",
      ritRequired: "Rit *",
      selectRit: "Rit seçin",
      enterRit: "Rit girin...",
      list: "Liste",
      vehiclePlateRequired: "Araç Plakası *",
      searchPlate: "Plaka ara ve seç...",
      selectFirmFirst: "Önce firma seçin",
      searchPlatePlaceholder: "Plaka ara...",
      vehicleNotFound: "Araç bulunamadı",
      orManualEntry: "veya manuel girin:",
      enterPlate: "Plaka girin...",
      driverRequired: "Şoför *",
      searchAndSelectDriver: "Şoför ara ve seç...",
      enterDriverName: "Şoför adı",
      allDrivers: "Tüm Şoförler",
      firmDrivers: "Firma Şoförleri",
      copilotLabel: "Yardımcı Şoför (Copilot)",
      searchAndSelectCopilot: "Yardımcı şoför ara ve seç...",
      enterCopilotName: "Yardımcı şoför adı",
      kmStartLabel: "KM Başlangıç",
      kmStartPlaceholder: "Örn: 40447",
      kmEndLabel: "KM Bitiş",
      kmEndPlaceholder: "Örn: 40531",
      hourlyRateLabel: "Saat Ücreti (€)",
      startCostLabel: "Başlangıç Maliyeti (€)",
      startTimeLabel: "Başlangıç Saati",
      endTimeLabel: "Bitiş Saati",
      breakTimeLabel: "Mola Süresi",
      calculatedValues: "Hesaplanan Değerler",
      totalKm: "Toplam KM:",
      workDuration: "Çalışma Süresi:",
      totalAmount: "Toplam Tutar:",
      notesLabel: "Notlar",
      notesPlaceholder: "Ek notlar...",
    },
    messages: {
      saveSuccess: "Route kaydedildi",
      saveError: "Route kaydedilemedi",
      deleteSuccess: "Route silindi",
      deleteError: "Route silinemedi",
      bulkDeleteSuccess: "kayıt silindi",
      bulkDeleteError: "Kayıtlar silinemedi",
      loadError: "Veriler yüklenemedi",
      exportSuccess: "kayıt indirildi",
      exportError: "Dışa aktarma hatası",
      recalculated: "kayıt yeniden hesaplandı",
      alreadyCorrect: "zaten doğru",
      recalculateError: "Yeniden hesaplama hatası",
      routeUpdated: "Route güncellendi",
      routeAdded: "Route eklendi",
      routeDeleted: "Route silindi",
      routeCopied: "Route kopyalandı",
      copyFailed: "Kopyalama başarısız",
      errorOccurred: "Bir hata oluştu",
      updated: "Güncellendi",
      updateError: "Güncelleme hatası",
      driverUpdated: "Şoför güncellendi",
      selectRecordsToDelete: "Lütfen silinecek kayıtları seçin",
      bulkDeleteConfirm: "{count} kayıt silinecek. Emin misiniz?",
      bulkDeleteError2: "Toplu silme hatası",
    },
    table: {
      clickToEdit: "Hücreye çift tıklayarak düzenleyebilirsiniz",
      hoverIcon: "hover'da kalem ikonu görünür",
      doubleClickStart: "Çift tıkla: Başlangıç saati",
      doubleClickEnd: "Çift tıkla: Bitiş saati",
    },
  },
  routeReports: {
    title: "Route Raporları",
    description: "Route ve tur istatistiklerini görüntüleyin",
    customer: "Müşteri",
    firm: "Firma",
    allFirms: "Tüm Firmalar",
    dateRange: "Tarih Aralığı",
    startDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    filter: "Filtrele",
    summary: "Özet İstatistikler",
    totalRoutes: "Toplam Route",
    totalHours: "Toplam Saat",
    totalKm: "Toplam KM",
    totalAmount: "Toplam Tutar",
    avgPerDay: "Günlük Ortalama",
    avgPerRoute: "Route Başına Ortalama",
    monthlyTrend: "Aylık Trend",
    weeklyTrend: "Haftalık Trend",
    driverStats: "Şoför İstatistikleri",
    vehicleStats: "Araç İstatistikleri",
    noData: "Seçilen kriterlere uygun veri bulunamadı",
    loadError: "Raporlar yüklenemedi",
    records: "Kayıt",
    currentPeriod: "Son Dönem",
    previousPeriod: "Önceki Dönem",
    last6MonthsLabel: "Son 6 Ay",
    previous6MonthsLabel: "Önceki 6 Ay",
    last12MonthsLabel: "Son 12 Ay",
    previous12MonthsLabel: "Önceki 12 Ay",
    driverDetails: "Şoför Detayları",
    routeCount: "Route Sayısı",
    totalIncome: "Toplam Gelir",
    periodComparison: "Dönem Karşılaştırması",
    last6Months: "Son 6 Ay vs Önceki",
    last12Months: "Son 12 Ay vs Önceki",
    growthSummary: "Büyüme Özeti",
    driverVehicleMatrix: "Şoför-Araç Performans Matrisi",
    driverVehicleMatrixDesc: "Her şoförün hangi araçla ne kadar performans gösterdiğini görün",
    driver: "Şoför",
    vehicleTotal: "Araç Toplamı",
    showingTopDrivers: "En yüksek performanslı",
    drivers: "şoför gösteriliyor",
  },
  lockedDates: {
    title: "Kilitli Tarihler",
    description: "Çalışanların izin talep edemeyeceği tarihleri yönetin",
    lockDate: "Tarih Kilitle",
    howItWorks: "Kilitli Tarihler Nasıl Çalışır?",
    infoLine1: "Kilitli tarihlerde çalışanlar izin talebi oluşturamaz",
    infoLine2: "\"Yıllık Tekrar\" seçeneği her yıl aynı tarihleri otomatik kilitler",
    infoLine3: "Tüm firmalar için veya belirli firmalar için kilitleme yapabilirsiniz",
    activeLockedDates: "Aktif Kilitli Tarihler",
    recordsFound: "kayıt bulundu",
    dates: "Tarihler",
    reason: "Sebep",
    firms: "Firmalar",
    repeat: "Tekrar",
    createdBy: "Oluşturan",
    noLockedDates: "Henüz kilitli tarih bulunmuyor",
    more: "daha",
    allFirms: "Tüm Firmalar",
    everyYear: "Her Yıl",
    oneTime: "Tek Seferlik",
    addNewTitle: "Yeni Kilitli Tarihler Ekle",
    addNewDescription: "Seçilen tarihlerde çalışanlar izin talebi oluşturamayacak",
    selectDates: "Tarihleri Seçin",
    datesSelected: "tarih seçildi",
    allFirmsApplies: "Tüm firmalar için geçerli olacak",
    firmsSelected: "firma seçildi",
    reasonPlaceholder: "Örn: Yıllık envanter sayımı, Şirket toplantısı...",
    repeatYearly: "Her Yıl Tekrarla",
    repeatYearlyDesc: "Bu tarihler her yıl otomatik olarak kilitlenecek",
    lockDates: "Tarihleri Kilitle",
    deleteTitle: "Kilitli Tarihleri Sil",
    deleteConfirm: "Bu işlem geri alınamaz. tarih kilidini kaldırmak istediğinizden emin misiniz?",
    datesCreated: "Kilitli tarihler oluşturuldu",
    datesDeleted: "Kilitli tarihler silindi",
    calendarView: "Takvim",
    listView: "Liste",
    calendarTitle: "Kilitli Tarihler Takvimi",
    lockedDay: "Kilitli Gün",
    today: "Bugün",
    lockedRecords: "kilitli kayıt",
  },
  dashboard: {
    totalApprovedDays: "Toplam Onaylı Gün",
    pendingRequests: "Bekleyen Talepler",
    approvedRequests: "Onaylı Talepler",
    rejectedRequests: "Reddedilen Talepler",
    monthlyApprovedDays: "Aylık Onaylı İzin Günleri",
    monthlyWorkStatus: "Aylık Çalışma Durumu",
    approvedDays: "Onaylı Günler",
    working: "Çalıştı",
    halfDay: "Yarım Gün",
    sick: "Hasta",
    dop: "DOP",
    onLeave: "İzinli",
    recentRequests: "Son Talepler",
    adjustment: "düzeltme",
    statusDistribution: "Durum Dağılımı",
    topLeaveTypes: "En Çok Kullanılan İzin Türleri",
    capacityHotspots: "Yoğun Günler",
    firmComparison: "Firma Karşılaştırması",
    // Employee planning widget
    myPlanning: "Planlamam",
    planningLoading: "Planlama yükleniyor...",
    upcomingCount: "{{count}} yakında",
    historyCount: "{{count}} geçmiş",
    viewList: "Liste",
    viewWeek: "Hafta",
    today: "Bugün",
    noAssignmentToday: "Bugün için atama yok.",
    nextSevenDays: "Yaklaşan 7 gün",
    historyWith: "Geçmiş ({{count}})",
    week: "Hafta",
    thisWeek: "Bugün",
    prevWeek: "Önceki hafta",
    nextWeek: "Sonraki hafta",
    weekDaysToggle: "5 veya 7 gün",
    sevenDaysShort: "7 gün",
    fiveDaysShort: "5 gün",
    daysShort: { 0: "Paz", 1: "Pzt", 2: "Sal", 3: "Çar", 4: "Per", 5: "Cum", 6: "Cmt" },
    monthsShort: { 0: "Oca", 1: "Şub", 2: "Mar", 3: "Nis", 4: "May", 5: "Haz", 6: "Tem", 7: "Ağu", 8: "Eyl", 9: "Eki", 10: "Kas", 11: "Ara" },
    quickActions: "Hızlı İşlemler",
    requests: "talep",
    globalView: "Genel Görünüm",
    allFirms: "Tüm Firmalar",
    activeEmployees: "Aktif Çalışanlar",
    pendingRegistrations: "Bekleyen Kayıtlar",
    todayWorking: "Bugün Çalışan",
    clickToSeeDetails: "Detaylar için tıklayın",
    todayStatus: "Bugünkü Durumunuz",
    noStatusYet: "Henüz belirlenmedi",
    createLeaveHint: "Hızlıca izin talebinizi oluşturun",
    workStatusHint: "Günlük çalışma durumunuzu görüntüleyin",
    myRecentRequests: "Son İzin Taleplerim",
    lastFiveRequests: "Son 5 talebiniz",
    viewAll: "Tümünü Gör",
    vehicleWarnings: "Araç Uyarıları",
    critical: "Kritik",
    warning: "Uyarı",
    viewAllVehicles: "Tümünü Gör",
    andMoreVehicles: "ve {{count}} araç daha...",
    andMorePeople: "ve {{count}} kişi daha... Tümünü Gör",
    allDocsUpToDate: "Tüm belgeler güncel",
    noExpiringDocs: "90 gün içinde süresi dolacak belge bulunmuyor.",
    expiryAlertSent: "{count} kişiye belge süresi bildirimi gönderildi.",
    noExpiryAlertNeeded: "Bildirim gönderilecek kişi bulunamadı.",
    sendAlert: "Bildirim Gönder",
    sendAlertError: "Bildirim gönderme başarısız oldu",
    checking: "Kontrol ediliyor...",
    checkExpiryTooltip: "Süresi dolmakta olan belgeler için kontrol et ve bildirimleri tetikle",
    todos: "Yapılacaklar",
    noTodos: "Açık görev yok.",
    markDone: "Tamamla",
    lastCheck: "Son kontrol",
    expired: "Süresi Doldu",
    criticalDays: "Kritik (30 gün)",
    warningDays: "Uyarı (90 gün)",
    totalPeople: "Toplam: {count} kişi",
    insuranceExpired: "Sigorta {days} gün önce doldu!",
    insuranceExpiring: "Sigorta {days} gün içinde dolacak",
    inspectionExpired: "Muayene {days} gün önce doldu!",
    inspectionExpiring: "Muayene {days} gün içinde dolacak",
    maintenanceOverdue: "Bakım {days} gün gecikti!",
    maintenanceUpcoming: "Bakım {days} gün içinde yapılmalı",
  },
  forgotPassword: {
    title: "Şifrenizi mi Unuttunuz?",
    subtitle: "E-posta adresinize doğrulama kodu göndereceğiz",
    description: "E-posta adresinizi girin, size e-posta ile doğrulama kodu gönderelim.",
    enterEmail: "E-posta adresinizi girin",
    invalidEmail: "Geçerli bir e-posta adresi girin",
    emailPlaceholder: "ornek@firma.com",
    emailHint: "Kayıtlı e-posta adresinizi girin. Doğrulama kodu bu adrese gönderilecektir.",
    sendCode: "Doğrulama Kodu Gönder",
    verifyCode: "Kodu Doğrulayın",
    codeSentEmail: "Doğrulama kodu e-posta adresinize gönderildi",
    enterCode: "Doğrulama Kodunu Girin",
    codeExpiry: "Kod 10 dakika içinde geçerliliğini yitirecektir",
    verify: "Doğrula",
    resendCode: "Kodu Tekrar Gönder",
    codeResent: "Yeni kod gönderildi",
    codeSent: "Doğrulama kodu gönderildi",
    codeVerified: "Kod doğrulandı",
    invalidCode: "Geçersiz kod",
    enterValidCode: "Lütfen 6 haneli kodu girin",
    newPassword: "Yeni Şifre",
    confirmPassword: "Şifreyi Onayla",
    newPasswordDesc: "En az 6 karakterli güçlü bir şifre oluşturun.",
    resetPassword: "Şifreyi Sıfırla",
    passwordTooShort: "Şifre en az 6 karakter olmalıdır",
    successTitle: "Şifreniz Değiştirildi!",
    successMessage: "Artık yeni şifrenizle giriş yapabilirsiniz.",
    successSubtitle: "Şifreniz başarıyla değiştirildi",
    successDesc: "Şifreniz başarıyla değiştirildi. Artık yeni şifrenizle giriş yapabilirsiniz.",
    rememberPassword: "Şifrenizi hatırladınız mı?",
    step1Label: "E-posta",
    step2Label: "Doğrulama",
    step3Label: "Şifre",
    passwordResetSuccess: "Şifreniz başarıyla sıfırlandı",
  },
  months: {
    jan: "Oca",
    feb: "Şub",
    mar: "Mar",
    apr: "Nis",
    may: "May",
    jun: "Haz",
    jul: "Tem",
    aug: "Ağu",
    sep: "Eyl",
    oct: "Eki",
    nov: "Kas",
    dec: "Ara",
  },
  auth: {
    email: "E-posta",
    password: "Şifre",
    passwordConfirm: "Şifre Tekrar",
    fullName: "Ad Soyad",
    gsm: "Telefon",
    language: "Dil",
    loginTitle: "Hesabınıza Giriş Yapın",
    registerTitle: "Yeni Hesap Oluşturun",
    registerRightTitle: "Topluluğumuza Katılın",
    registerRightDesc: "Hesabınızı oluşturun ve izin taleplerini verimli bir şekilde yönetmeye başlayın.",
    registerSuccessTitle: "Kayıt Başarılı!",
    registerSuccessMsg: "Hesabınız oluşturuldu. Yönetici onayından sonra giriş yapabilirsiniz.",
    pendingApproval: "Hesabınız onay bekliyor. Lütfen admin onayını bekleyin.",
    forgotPassword: "Şifremi Unuttum",
    noAccount: "Hesabınız yok mu?",
    hasAccount: "Zaten hesabınız var mı?",
    welcomeBack: "Hesabınıza giriş yapın",
    loginSuccess: "Giriş başarılı",
    rememberMe: "Beni hatırla",
    biometricLogin: "Biyometrik Giriş",
    biometricNotRegistered: "Bu cihazda biyometrik kayıt bulunamadı",
    orBiometric: "veya",
    registerSuccess: "Kayıt başarılı. Hesabınız onay bekliyor.",
    invalidCredentials: "Geçersiz e-posta veya şifre",
    accountPending: "Hesabınız onay bekliyor. Lütfen admin onayını bekleyin.",
    accountRejected: "Hesabınız reddedildi.",
    accountCreated: "Hesabınız başarıyla oluşturulmuştur.",
    firmAssignmentPending: "Firma atamanız yapıldıktan sonra, hesabınızın onay süreci tamamlanacak ve tarafınıza bilgilendirme yapılacaktır.",
    loginAfterApproval: "Onay süreci tamamlanana kadar giriş işlemi yapılamayacaktır.",
    step1: "Kişisel Bilgiler",
    step2: "Güvenlik",
    invalidResetLink: "Geçersiz şifre sıfırlama linki",
    invalidLink: "Geçersiz Link",
    setNewPassword: "Yeni Şifre Belirle",
    setNewPasswordDescription: "Hesabınız için yeni bir şifre belirleyin",
    newPassword: "Yeni Şifre",
    confirmNewPassword: "Yeni Şifre (Tekrar)",
    passwordMinLength: "Şifre en az 6 karakter olmalıdır",
    passwordsDoNotMatch: "Şifreler eşleşmiyor",
    passwordResetSuccess: "Şifreniz başarıyla değiştirildi",
    passwordChanged: "Şifre Değiştirildi",
    passwordResetSuccessMessage: "Şifreniz başarıyla değiştirildi. Artık yeni şifrenizle giriş yapabilirsiniz.",
    setPassword: "Şifreyi Belirle",
    backToLogin: "Giriş sayfasına dön",
    twoFA: "İki Faktörlü Doğrulama (2FA)",
    twoFAVerification: "2FA Doğrulama",
    twoFASetup: "2FA Kurulumu",
    twoFAEnabled: "2FA Aktif",
    twoFADisabled: "2FA Pasif",
    twoFAActive: "Aktif",
    twoFAInactive: "Pasif",
    twoFAProtected: "Hesabınız iki faktörlü doğrulama ile korunuyor",
    twoFAEncourage: "Hesabınızı daha güvenli hale getirmek için 2FA'yı etkinleştirin",
    twoFASupportedApps: "Google Authenticator, Microsoft Authenticator, Authy ve diğer TOTP uygulamaları desteklenir",
    twoFAEnable: "2FA Etkinleştir",
    twoFADisable: "2FA Devre Dışı Bırak",
    twoFABackupCodes: "Yedek Kodlar",
    twoFAYourBackupCodes: "Yedek Kodlarınız",
    twoFAScanQR: "Authenticator uygulamanızla aşağıdaki QR kodu tarayın:",
    twoFACantScanQR: "QR kod tarayamıyorsanız",
    twoFAScannedNext: "Taradım, devam et",
    twoFAEnterCode: "Authenticator uygulamanızdan alınan 6 haneli kodu giriniz:",
    twoFAVerifyAndEnable: "Doğrula ve Etkinleştir",
    twoFASaveBackupCodes: "Bu yedek kodları güvenli bir yere kaydedin. Authenticator uygulamanıza erişemezseniz bu kodlarla giriş yapabilirsiniz.",
    twoFACopyCodes: "Kodları Kopyala",
    twoFAComplete: "Tamamla",
    twoFADisableConfirm: "2FA'yı devre dışı bırakmak için şifrenizi giriniz:",
    twoFAYourPassword: "Şifreniz",
    twoFACancel: "İptal",
    twoFARemainingCodes: "Kalan: {count} kod",
    twoFACopy: "Kopyala",
    twoFARegenerate: "Yenile",
    twoFACopied: "Kopyalandı!",
    twoFALoginPrompt: "authenticator uygulamanızdan 6 haneli kodu giriniz",
    twoFALoginBackupPrompt: "yedek kodunuzu giriniz",
    twoFAUseBackupCode: "Yedek kod kullan",
    twoFAUseAuthCode: "Authenticator kodunu kullan",
    twoFABackToLogin: "Girişe geri dön",
    twoFASecureConnection: "Güvenli bağlantı kuruldu",
    registrationPending: "Kayıt İşleniyor",
    waitingApproval: "Onay Bekleniyor",
  },
  login: {
    heroTitle: "Ekibinizin izinlerini verimli yönetin",
    heroDescription: "İzin taleplerini, onaylarını ve takibini tek platformda kolaylaştırın.",
  },
  leave: {
    annual: "Yıllık İzin",
    sick: "Hastalık İzni",
    personal: "Kişisel İzin",
    paternity: "Babalık İzni",
    kleinVerlet: "Klein-Verlet",
    unpaid: "Ücretsiz İzin",
    total: "Toplam",
    used: "Kullanılan",
    remaining: "Kalan",
    entitled: "Hak Edilen",
    request: "İzin Talebi",
    requests: "İzin Talepleri",
    newRequest: "Yeni Talep Oluştur",
    balances: "İzin Bakiyeleri",
    days: "gün",
    day: "gün",
    selectYear: "Yıl Seçin",
    noBalances: "Henüz izin bakiyesi bulunmuyor",
    adjustBalance: "Bakiye Düzenleme",
    adjustmentReason: "Düzenleme Nedeni",
    addDays: "Gün Ekle",
    removeDays: "Gün Çıkar",
    adjustmentHistory: "Düzenleme Geçmişi",
    requiresDocument: "Belge Gerektirir",
    leaveTypes: "İzin Türleri",
    viewBalances: "Bakiyeleri Görüntüle",
    previousYears: "Önceki Yıllar",
    createRequest: "İzin Talebi Oluştur",
    selectType: "İzin Türü Seçin",
    type: "İzin Türü",
    selectedType: "Seçilen İzin Türü",
    selectDates: "Tarih Seçimi",
    reviewSubmit: "İncele ve Gönder",
    startDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    description: "Açıklama",
    descriptionPlaceholder: "İzin talebiniz hakkında not ekleyin...",
    documentUpload: "Belge Yükle",
    documentOptional: "Belge yükleme opsiyoneldir",
    documentRecommended: "Bu izin türü için belge önerilir",
    confirmRequest: "Bu talebin doğru olduğunu onaylıyorum",
    submitRequest: "Talep Gönder",
    requestCreated: "İzin talebi başarıyla oluşturuldu",
    requestUpdated: "İzin talebi güncellendi",
    requestCancelled: "İzin talebi iptal edildi",
    requestDeleted: "İzin talebi silindi",
    deleteRequest: "Talebi Sil",
    deleteRequestConfirm: "Bu izin talebini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    noRequests: "Henüz izin talebiniz bulunmuyor",
    cancelRequest: "Talebi İptal Et",
    editRequest: "Talebi Düzenle",
    viewDetails: "Detayları Görüntüle",
    insufficientBalance: "Yetersiz izin bakiyesi",
    datesOverlap: "Seçilen tarihler mevcut bir izin talebiyle çakışıyor",
    step1Title: "Adım 1: İzin türü seçin",
    step2Title: "Adım 2: Tarih seçin",
    selectDaysHint: "Takvimden en az bir gün seçin",
    locked: "Kilitli",
    blockedDays: "Dolu Günler",
    blockedDaysWarning: "Seçilen tarihler dolu günler içeriyor",
    dayFullyBooked: "Bu gün dolu (5+ onaylı izin)",
    calendarView: "Takvim Görünümü",
    selectedRange: "Seçili Tarihler",
    pending: "Beklemede",
    approved: "Onaylandı",
    rejected: "Reddedildi",
    cancelled: "İptal Edildi",
    step1: "Adım 1",
    step2: "Adım 2",
    step3: "Adım 3",
    summary: "Özet",
    myRequests: "İzin Taleplerim",
    archived: "Arşivlendi",
    selectTypeFirst: "Önce izin türü seçin",
    selectDays: "En az bir gün seçin",
    noDaysSelected: "Takvimden gün seçin",
    totalDays: "Toplam Gün",
    selectedDays: "Seçilen Günler",
    selectedDates: "Seçilen Tarihler",
    selected: "Seçili",
    weekend: "Hafta Sonu",
    calendarTip: "Takvim üzerinden izin almak istediğiniz günleri seçin. Seçimi kaldırmak için tekrar tıklayın.",
    calendarTipShort: "Günlere tıklayarak seçin/kaldırın",
    requestedAt: "Talep Tarihi",
    more: "daha",
    daysAvailable: "gün kaldı",
    maxDays: "Maks",
    maxDaysReached: "Bu izin türü için maksimum {days} gün seçebilirsiniz",
    selectLeaveTypeFirst: "Önce izin türü seçin",
    selectLeaveTypeFirstDesc: "Tarih seçimi için önce yukarıdan izin türünü seçmeniz gerekmektedir",
    noRemainingDays: "Kalan gün yok",
    remainingDays: "Kalan Gün",
    requestSubmitted: "İzin talebi gönderildi",
    selectLeaveType: "İzin türü seçin",
  },
  leaveCalendar: {
    deleteLeave: "İzni Sil",
    deleteConfirmTitle: "İzni Sil",
    deleteConfirmMessage: "Bu izni silmek istediğinizden emin misiniz?",
    deleteBalanceNote: "Onaylı izinlerde kullanılan gün bakiyeye iade edilecektir.",
    confirmDelete: "Evet, Sil",
    deleteSuccess: "İzin başarıyla silindi",
    deleteError: "İzin silinirken hata oluştu",
    balanceRestored: "{days} gün bakiyeye iade edildi",
    cannotDeletePast: "Geçmiş tarihli izinler silinemez",
    removeThisDay: "Sadece Bu Günü Sil",
    removeDayConfirmTitle: "Bu Günü Sil",
    removeDayConfirmMessage: "Bu günü izinden çıkarmak istediğinizden emin misiniz?",
    confirmRemoveDay: "Evet, Bu Günü Sil",
    deleteEntireLeave: "Tüm İzni Sil",
    dayRemovedSuccess: "{date} tarihli gün izinden çıkarıldı",
    removeDayError: "Gün çıkarılırken hata oluştu",
  },
  admin: {
    userManagement: "Kullanıcı Yönetimi",
    createUser: "Kullanıcı Ekle",
    createUserDesc: "Sisteme manuel olarak yeni bir kullanıcı ekleyin",
    firmManagement: "Firma Yönetimi",
    pendingApprovals: "Onay Bekleyenler",
    auditLogs: "Denetim Kayıtları",
    statistics: "İstatistikler",
    totalUsers: "Toplam Kullanıcı",
    totalFirms: "Toplam Firma",
    pendingUsers: "Bekleyen Kullanıcı",
    activeUsers: "Aktif Kullanıcı",
    approveUser: "Kullanıcıyı Onayla",
    rejectUser: "Kullanıcıyı Reddet",
    rejectReason: "Red Nedeni",
    selectFirm: "Firma Seçin",
    createFirm: "Yeni Firma",
    firmName: "Firma Adı",
    firmLogo: "Firma Logosu",
    selectRole: "Rol Seçin",
    roleEmployee: "Çalışan",
    roleFirmAdmin: "Firma Yöneticisi",
    confirmApprove: "Bu kullanıcıyı onaylamak istediğinizden emin misiniz?",
    confirmReject: "Bu kullanıcıyı reddetmek istediğinizden emin misiniz?",
    approveConfirmation: "Onaylama işlemi geri alınamaz.",
    rejectConfirmation: "Reddetme işlemi geri alınamaz.",
    firmRequired: "Firma seçimi zorunludur",
    reasonRequired: "Red nedeni zorunludur (en az 5 karakter)",
    userApproved: "Kullanıcı başarıyla onaylandı",
    userRejected: "Kullanıcı reddedildi",
    pendingTab: "Bekleyenler",
    activeTab: "Aktifler",
    rejectedTab: "Reddedilenler",
    createdAt: "Kayıt Tarihi",
    leaveRequestManagement: "İzin Yönetimi",
    leaveManagement: "İzin Yönetimi",
    listView: "Liste",
    calendarView: "Takvim",
    approveRequest: "Talebi Onayla",
    rejectRequest: "Talebi Reddet",
    cancelRequest: "Talebi İptal Et",
    archiveRequest: "Arşivle",
    editRequest: "Düzenle",
    confirmApproveLeave: "Bu izin talebini onaylamak istediğinizden emin misiniz?",
    confirmRejectLeave: "Bu izin talebini reddetmek istediğinizden emin misiniz?",
    confirmCancelLeave: "Bu onaylı izin talebini iptal etmek istediğinizden emin misiniz?",
    confirmArchiveLeave: "Bu izin talebini arşivlemek istediğinizden emin misiniz?",
    leaveApproved: "İzin talebi onaylandı",
    leaveApprovedWithWarnings: "İzin uyarılarla onaylandı (Süper Admin geçici izni)",
    warn: {
      insufficientBalance: "Yetersiz bakiye: {{requested}} gün talep, {{available}} gün mevcut",
      daysFullyBooked: "Bu günler tam dolu (5+ onaylı izin): {{dates}}",
      lockedDates: "Kilitli tarihler: {{dates}}",
      dateOverlap: "Tarihler başka bir onaylı izinle çakışıyor",
      noBalance: "İzin bakiyesi bulunamadı",
    },
    leaveRejected: "İzin talebi reddedildi",
    leaveCancelled: "İzin talebi iptal edildi",
    leaveArchived: "İzin talebi arşivlendi",
    leaveUpdated: "İzin talebi güncellendi",
    samePeriodsOnLeave: "Bu tarihlerde izinli personel:",
    overlappingDates: "Çakışan tarihler",
    requester: "Talep Eden",
    leaveType: "İzin Türü",
    dateRange: "Tarih Aralığı",
    daysCount: "Gün Sayısı",
    requestDate: "Talep Tarihi",
    adminNote: "Admin Notu",
    adminNotePlaceholder: "Admin notu (isteğe bağlı)...",
    enterReason: "Neden girin",
    notifyUser: "Kullanıcıyı Bilgilendir",
    notifyBySms: "SMS ile",
    notifyByEmail: "E-posta ile",
    notifyByWhatsapp: "WhatsApp ile",
    balanceInfo: "Bakiye Bilgisi",
    capacityWarning: "Kapasite Uyarısı",
    archivedTab: "Arşiv",
    allRequests: "Tüm Talepler",
    approveLeaveConfirmation: "Bu kullanıcının izin talebini son kez onaylıyorsunuz.",
    rejectReasonRequired: "Red nedeni zorunludur",
    deleteUser: "Kullanıcı Sil",
    confirmDeleteUser: "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
    userDeleted: "Kullanıcı silindi",
    deleteWarning: "Bu işlem geri alınamaz!",
    deleteLeaveRequest: "İzin Talebini Sil",
    confirmDeleteLeaveRequest: "Bu izin talebini kalıcı olarak silmek istediğinizden emin misiniz?",
    leaveRequestDeleted: "İzin talebi silindi",
    hardDelete: "HardSil",
    hardDeleteTitle: "HardSil - Zorla Sil (Süper Admin)",
    hardDeleteWarning: "Bu işlem tüm doğrulamaları atlayarak izin kaydını KALICI olarak siler. Bakiye iade edilmez. Geçmiş kayıtlar dahil her kayıt silinebilir.",
    hardDeleteConfirmPrompt: "Onaylamak için aşağıya büyük harflerle HARDSIL yazın:",
    hardDeleteConfirmWord: "HARDSIL",
    hardDeleteConfirmButton: "Evet, Zorla Sil",
    hardDeleteSuccess: "İzin talebi zorla silindi (HardSil)",
    hardDeleteTooltip: "HardSil: Kuralları atlayarak zorla sil (Sadece Süper Admin)",
    frontendSettings: "Site Ayarları",
    frontendSettingsDescription: "Ana sayfa, giriş ve üyelik sayfalarının görünümünü yönetin",
    siteName: "Site Adı",
    siteNameDesc: "Uygulamanın başlığını ve marka adını değiştirin",
    siteNameLabel: "Site Adı",
    siteNameHelp: "Bu isim navbar, başlık ve footer'da görünür",
    landingPageToggle: "Ana Sayfa Kontrolü",
    landingPageToggleDesc: "Ana sayfanın görünürlüğünü kontrol edin",
    enableLandingPage: "Ana Sayfayı Etkinleştir",
    landingPageNote: "Kapalıyken, kullanıcılar doğrudan giriş sayfasına yönlendirilir",
    landingDisabledWarning: "Ana sayfa kapalı. Kullanıcılar doğrudan giriş sayfasına yönlendirilecek.",
    pageImages: "Sayfa Görselleri",
    pageImagesDesc: "Sayfaların arka plan görsellerini ayarlayın",
    landingPageImage: "Ana Sayfa Görseli",
    loginPageImage: "Giriş Sayfası Görseli",
    registerPageImage: "Üyelik Sayfası Görseli",
    settingsSaved: "Ayarlar kaydedildi",
    superAdminRequired: "Bu sayfaya erişmek için Süper Admin yetkisi gereklidir",
    searchUsers: "Ad, e-posta veya telefon ile ara...",
    allFirms: "Tüm Firmalar",
    firm: "Firma",
    noUsersFound: "Kullanıcı bulunamadı",
    viewDetails: "Detaylar",
    fullName: "Ad Soyad",
    email: "E-posta",
    phone: "Telefon",
    role: "Rol",
    status: "Durum",
    suspended: "Askıda",
    suspendUser: "Askıya Al",
    activateUser: "Aktif Et",
    activate: "Aktif Et",
    suspend: "Askıya Al",
    activateConfirm: "Bu kullanıcı aktif edilecek ve sisteme giriş yapabilecek.",
    suspendConfirm: "Bu kullanıcı askıya alınacak ve sisteme giriş yapamayacak.",
    userActivated: "Kullanıcı aktif edildi",
    userSuspended: "Kullanıcı askıya alındı",
    reapprove: "Tekrar Onayla",
    employee: "Çalışan",
    firmAdmin: "Firma Admin",
    confirmApproval: "Onayı Doğrula",
    approvalSummary: "Onay Özeti",
    rejectionWarning: "Dikkat",
    rejectionMessage: "Bu kullanıcı reddedilecek ve sisteme giriş yapamayacak.",
    reason: "Sebep",
    rejectReasonPlaceholder: "Red sebebini açıklayın...",
    deleteUserWarning: "Bu işlem geri alınamaz. Kullanıcının tüm verileri silinecektir.",
    impersonate: "Panele Gir",
    sendPasswordReset: "Şifre Sıfırlama Gönder",
    sendPasswordResetTitle: "Şifre Sıfırlama Emaili Gönder",
    passwordResetSent: "Şifre sıfırlama linki {email} adresine gönderildi",
    sendEmail: "Email Gönder",
    setPassword: "Şifre Belirle",
    setPasswordTitle: "Şifre Belirle",
    newPassword: "Yeni Şifre",
    generatePassword: "Rastgele Oluştur",
    setPasswordConfirm: "Şifreyi Kaydet",
    changeFirm: "Firma Değiştir",
    newFirm: "Yeni Firma",
    transfer: "Aktar",
    transferSuccess: "Kullanıcı başarıyla aktarıldı",
    selectDifferentFirm: "Lütfen farklı bir firma seçin",
    firmTransferWarning: "Bu işlem kullanıcının izin bakiyelerini etkilemez.",
    changeRole: "Rol Değiştir",
    pagePermissions: "Sayfa Yetkisi",
    allowedFirms: "Erişebileceği Firmalar",
    allowedFirmsDesc: "Boş bırakılırsa hiçbir firmayı göremez",
    pageAccess: "Sayfa Erişimi",
    pageAccessDesc: "Boş bırakılırsa tüm sayfalara erişebilir",
    additionalPermissions: "Ek Yetkiler",
    canDelete: "Silme Yetkisi",
    canDeleteDesc: "Kayıt silme işlemi yapabilir",
    canViewFinancial: "Finansal Kayıtları Görme",
    canViewFinancialDesc: "Finansal kayıt ekleme ve avans bölümünü görebilir",
    canSendNotifications: "Bildirim Gönderme",
    canSendNotificationsDesc: "Kullanıcılara bildirim gönderebilir",
    newRole: "Yeni Rol",
    changeRoleBtn: "Rolü Değiştir",
    roleChanged: "Kullanıcı rolü değiştirildi",
    selectDifferentRole: "Lütfen farklı bir rol seçin",
    firmAdminWarning: "Firma Admin, kendi firmasındaki kullanıcıları ve izin taleplerini yönetebilir.",
    export: "Dışa Aktar",
    import: "İçe Aktar",
    importUsers: "Kullanıcı İçe Aktar",
    exportSuccess: "Kullanıcılar dışa aktarıldı",
    importSuccess: "Kullanıcılar içe aktarıldı",
    importAndUpdate: "İçe Aktar ve Güncelle",
    importPreview: "Önizleme",
    importResults: "Sonuçlar",
    created: "Oluşturuldu",
    updated: "Güncellendi",
    skipped: "Atlandı",
    errors: "Hatalar",
    impersonateAs: "olarak görüntülüyorsunuz",
    returnToAdmin: "hesabına geri dön",
    deleteLeaveRequestSuccess: "İzin talebi silindi",
    deleteUserDesc: "Bu işlem geri alınamaz. Kullanıcı ve ilgili tüm veriler silinecektir.",
    deleteUserSuccess: "Kullanıcı silindi",
    enterPanel: "Panele Gir",
    fullAdminWarning: "Full Admin atanmış firmalar genelinde kullanıcı ve izin taleplerini yönetebilir.",
    loginAs: "Olarak Giriş Yap",
    permissionsSaved: "İzinler kaydedildi",
    resetPassword: "Şifreyi Sıfırla",
    sendResetPassword: "Şifre Sıfırlama Gönder",
    suspendUserDesc: "Askıya alınan kullanıcılar sisteme giriş yapamaz.",
    unsuspendUser: "Kullanıcıyı Aktifleştir",
    updatePermissions: "İzinleri Güncelle",
    userDetails: "Kullanıcı Detayları",
    userUnsuspended: "Kullanıcı aktifleştirildi",
    confirmRejection: "Reddetmek istediğinizden emin misiniz?",
  },
  profile: {
    changePassword: "Şifre Değiştir",
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    confirmNewPassword: "Yeni Şifre (Tekrar)",
    passwordChanged: "Şifre başarıyla değiştirildi",
    passwordMismatch: "Yeni şifreler eşleşmiyor",
    incorrectPassword: "Mevcut şifre yanlış",
    accountInfo: "Hesap Bilgileri",
    company: "Firma",
    role: "Rol",
    memberSince: "Üyelik Tarihi",
    lastLogin: "Son Giriş",
    accountStatus: "Hesap Durumu",
    accountActive: "Hesabınız aktif durumda",
    accountInactive: "Hesabınız pasif durumda",
    languageSettings: "Dil Ayarları",
    accountRejected: "Hesabınız reddedildi",
    darkMode: "Karanlık Mod",
    phone: "Telefon",
    phoneNumber: "Telefon Numarası",
    waitingApproval: "Onay bekleniyor",
    email: "E-posta",
    fullName: "Ad Soyad",
    language: "Dil",
    settings: "Ayarlar",
    theme: "Tema",
  },
  landing: {
    heroTitle: "İzin Yönetiminde Yeni Nesil",
    heroSubtitle: "Çalışanlarınızın izin taleplerini dijital ortamda kolayca yönetin, onaylayın ve takip edin.",
    getStarted: "Hemen Başlayın",
    learnMore: "Daha Fazla Bilgi",
    features: "Özellikler",
    feature1Title: "Kolay İzin Takibi",
    feature1Desc: "Yıllık, hastalık ve kişisel izinlerinizi tek panelden takip edin.",
    feature2Title: "Hızlı Onay Süreci",
    feature2Desc: "Yöneticiler izin taleplerini anında onaylayabilir veya reddedebilir.",
    feature3Title: "Çoklu Firma Desteği",
    feature3Desc: "Birden fazla firmayı tek platformdan yönetin.",
  },
  notifications: {
    title: "Bildirimler",
    subtitle: "SMS, E-posta ve WhatsApp bildirim ayarlarını yönetin",
    settings: "Ayarlar",
    outbox: "Gönderim Kutusu",
    enabled: "Etkin",
    disabled: "Devre Dışı",
    channel: "Kanal",
    event: "Olay",
    recipient: "Alıcı",
    status: "Durum",
    attempts: "Deneme",
    message: "Mesaj",
    details: "Detaylar",
    lastError: "Son Hata",
    settingsSaved: "Bildirim ayarları kaydedildi",
    testSend: "Test Gönderimi",
    testDescription: "Bu kanal için test bildirimi gönderin",
    testSent: "Test bildirimi gönderildi",
    retryQueued: "Yeniden gönderim için kuyruğa alındı",
    send: "Gönder",
    providerUrl: "Sağlayıcı URL",
    apiKey: "API Anahtarı",
    sender: "Gönderen",
    timeout: "Zaman Aşımı (ms)",
    smtpHost: "SMTP Sunucusu",
    smtpPort: "SMTP Portu",
    smtpUser: "SMTP Kullanıcı",
    smtpPass: "SMTP Şifre",
    fromAddress: "Gönderen Adresi",
    emailAddress: "E-posta Adresi",
    phoneNumber: "Telefon Numarası",
    emailProvider: "E-posta Sağlayıcısı",
    mandrillApiKey: "Mandrill API Anahtarı",
    fromName: "Gönderen Adı",
    replyTo: "Yanıt Adresi",
    smsApiNote: "API gsm, mesaj, mesajturu parametreleri ile çağrılır",
    defaultMesajTuru: "Varsayılan Mesaj Türü",
    retry: "Tekrar Dene",
    retryWithReset: "Sıfırlayarak Tekrar Dene",
    confirmDelete: "Bu bildirimi silmek istediğinizden emin misiniz?",
    deleted: "Bildirim silindi",
    selectToDelete: "Silmek için bildirim seçin",
  },
  validation: {
    required: "Bu alan zorunludur",
    invalidEmail: "Geçerli bir e-posta adresi girin",
    passwordMin: "Şifre en az 6 karakter olmalıdır",
    passwordMatch: "Şifreler eşleşmiyor",
    phoneFormat: "Geçerli bir telefon numarası girin",
  },
  calendar: {
    title: "İzin Takvimi",
    description: "Onaylanan izinlerin takvim görünümü",
    monthly: "Aylık",
    weekly: "Haftalık",
    today: "Bugün",
    employeesOnLeave: "İzindeki Çalışanlar",
    totalLeaveDays: "Toplam İzin Günü",
    approvedLeaves: "Onaylı İzin",
    monday: "Pzt",
    tuesday: "Sal",
    wednesday: "Çar",
    thursday: "Per",
    friday: "Cum",
    saturday: "Cmt",
    sunday: "Paz",
  },
  leaveTypes: {
    title: "İzin Türleri",
    description: "Sistemdeki izin türlerini yönetin",
    add: "Yeni İzin Türü",
    total: "Toplam",
    active: "Aktif",
    inactive: "Pasif",
    code: "Kod",
    name: "İsim",
    defaultDays: "Varsayılan Gün",
    defaultLabel: "Varsayılan",
    requiresDocument: "Belge Gerekli",
    status: "Durum",
    isActive: "Aktif",
    createTitle: "Yeni İzin Türü Oluştur",
    createDescription: "Sistemde kullanılacak yeni bir izin türü tanımlayın",
    editTitle: "İzin Türünü Düzenle",
    edit: "Düzenle",
    deleteTitle: "İzin Türünü Sil",
    created: "İzin türü oluşturuldu",
    updated: "İzin türü güncellendi",
    deleted: "İzin türü silindi",
    activated: "İzin türü aktif edildi",
    deactivated: "İzin türü pasif yapıldı",
    codeAndNameRequired: "Kod ve Türkçe isim zorunludur",
    noData: "Henüz izin türü tanımlanmamış",
    viewUsers: "Kullanıcılar",
    usersWithType: "Bu İzin Türüne Sahip Kullanıcılar",
    totalBalances: "Toplam Bakiye",
    totalRequests: "Toplam Talep",
    noUsersWithType: "Bu izin türünü kullanan kimse yok",
    canSafelyDelete: "Bu izin türünü güvenle silebilirsiniz",
    balanceRemoved: "Bakiye kaldırıldı",
    removeBalance: "Bakiyeyi Kaldır",
    cannotRemoveWithRequests: "İzin talepleri olan kullanıcıların bakiyesi silinemez",
    warningRequestsExist: "Bu izin türüyle izin talepleri mevcut. Silmeden önce bakiyeleri kaldırın.",
    adminOnly: "Sadece Admin",
    adminOnlyDesc: "Kullanıcılar izin talebinde bu türü göremez",
    yes: "Evet",
    no: "Hayır",
    days: "gün",
    orphanBalance: "Yetim Bakiye",
    duplicateCheck: "Mükerrer Kontrol",
    color: "Renk",
    onlyUppercaseAndUnderscore: "Sadece büyük harf ve alt çizgi",
    daysCountChanged: "Gün sayısı değiştirildi",
  },
  customers: {
    title: "Müşteri Tanımları",
    description: "Route form alanlarını müşteri bazında yönetin",
    newCustomer: "Yeni Müşteri Oluştur",
    editCustomer: "{{name}} Düzenle",
    name: "Müşteri Adı",
    nameRequired: "Müşteri adı zorunludur",
    slug: "Slug (Benzersiz Kod)",
    color: "Renk",
    bgColor: "Arkaplan Renk Sınıfı",
    sortOrder: "Sıra",
    calculationType: "Hesaplama Tipi",
    fields: "Alanlar",
    fieldOptions: "Alan Seçenekleri (JSON)",
    defaultValues: "Varsayılan Değerler (JSON)",
    systemCustomer: "Sistem Müşterisi",
    systemCannotDelete: "Sistem müşterileri silinemez",
    deleteConfirm: "Bu müşteriyi silmek istediğinizden emin misiniz?",
    created: "Müşteri oluşturuldu",
    updated: "Müşteri güncellendi",
    deleted: "Müşteri silindi",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    hoursRate: "Saat x Ücret",
    stopsPrice: "Durak x Fiyat",
    fixedRate: "Sabit Ücret",
    manualTotal: "Manuel Toplam",
    availableFields: "Kullanılabilir Alanlar",
    addButton: "Yeni Müşteri",
    system: "Sistem",
    custom: "Özel",
    noCustomers: "Henüz müşteri tanımlanmamış",
    deleteTitle: "Müşteri Sil",
    deleteMessage: "{{name}} müşterisini silmek istediğinize emin misiniz?",
    atLeastOneField: "En az bir alan seçmelisiniz",
    operationFailed: "İşlem başarısız",
    cannotDelete: "Silinemedi",
    deleteFailed: "Silme işlemi başarısız",
    errorOccurred: "Hata oluştu",
    calculationMethod: "Hesaplama Yöntemi",
    formFields: "Form Alanları",
    fieldsSelected: "alan seçili",
    defaultValue: "Varsayılan",
    preview: "Önizleme",
    calculation: "Hesaplama",
    update: "Güncelle",
    create: "Oluştur",
    example: "Ör",
    defaultsCreated: "Varsayılan müşteriler oluşturuldu",
    namePlaceholder: "Müşteri adı",
    slugPlaceholder: "musteri_slug",
    categoryBase: "Temel Alanlar",
    categoryIdentity: "Kimlik / Numara",
    categoryPersonnel: "Personel",
    categoryDistance: "Mesafe",
    categoryPricing: "Ücretlendirme",
    categoryTime: "Zaman",
  },
  vehicles: {
    title: "Araçlarım",
    detail: "Araç Detayı",
    generalInfo: "Genel Bilgiler",
    technicalInfo: "Teknik Bilgiler",
    ownershipSale: "Sahiplik & Satış",
    notes: "Notlar",
    noNotes: "Not bulunmuyor",
    documents: "Belgeler",
    photos: "Fotoğraflar",
    maintenanceInsurance: "Bakım & Sigorta",
    insurance: "Sigorta",
    inspection: "Muayene",
    maintenance: "Bakım",
    activeWarnings: "Aktif Uyarılar",
    insuranceCompany: "Sigorta Şirketi",
    expiryDate: "Bitiş Tarihi",
    lastMaintenance: "Son Bakım",
    nextMaintenance: "Sonraki Bakım",
    lastMaintenanceKm: "Son Bakım KM",
    nextMaintenanceKm: "Sonraki Bakım KM",
    plate: "Plaka",
    brand: "Marka",
    model: "Model",
    buildYear: "Bouwjaar",
    color: "Renk",
    firm: "Firma",
    chassisNumber: "Chassisnummer",
    loadCapacity: "Laadvermogen",
    fuelType: "Brandstof",
    permitNumber: "Vergunningnummer",
    sticker: "Sticker",
    leaseOwnership: "Lease / Eigendom",
    purchaseLocation: "Satın Alma Yeri",
    purchaseDate: "Satın Alma Tarihi",
    saleDate: "Satış Tarihi",
    edit: "Düzenle",
    save: "Kaydet",
    cancelEdit: "İptal",
    uploadDoc: "Yükle",
    uploadPhoto: "Fotoğraf Yükle",
    dragDropDocs: "Dosyaları buraya sürükleyip bırakın",
    dragDropPhotos: "Fotoğrafları buraya sürükleyip bırakın",
    orUseButton: "veya yükle butonunu kullanın",
    keuring: "Keuring",
    ruhsat: "Inschrijvingsbewijs (Ruhsat)",
    vergunning: "Vergunning",
    sigortaPolicesi: "Sigorta Poliçesi",
    muayeneRaporu: "Muayene Raporu",
    bakimRaporu: "Bakım Raporu",
    subtitle: "Firma araçlarını yönetin",
    sendReminder: "Hatırlatma Gönder",
    excelUpload: "Excel Yükle",
    newVehicle: "Yeni Araç",
    searchLabel: "Ara",
    searchPlaceholder: "Plaka, marka, model, firma...",
    fuelTypeFilter: "Yakıt Tipi",
    statusFilter: "Durum",
    all: "Tümü",
    ok: "Sorunsuz",
    warningStatus: "Uyarılı",
    criticalStatus: "Kritik",
    totalVehicles: "Toplam Araç",
    firmCount: "Firma Sayısı",
    hasWarnings: "Uyarı Var",
    hasCritical: "Kritik",
    brandDistribution: "Marka Dağılımı",
    fuelDistribution: "Yakıt Tipi Dağılımı",
    unknownBrand: "Bilinmiyor",
    notSpecified: "Belirtilmemiş",
    noDataFound: "Veri bulunamadı",
    vehicleList: "Araç Listesi",
    vehicleCount: "araç",
    totalLabel: "toplam",
    hideChart: "Grafiği Kapat",
    showBrandChart: "Marka Grafiği",
    selectedCount: "araç seçili",
    deleteSelected: "Seçilenleri Sil",
    noVehicles: "Araç bulunamadı",
    addFirst: "İlk Aracı Ekle",
    editVehicle: "Araç Düzenle",
    addVehicle: "Yeni Araç Ekle",
    plateRequired: "Plaka zorunludur",
    firmRequired: "Firma seçimi zorunludur",
    vehicleUpdated: "Araç güncellendi",
    vehicleAdded: "Araç eklendi",
    vehicleDeleted: "Araç silindi",
    deleteError: "Silme hatası",
    importError: "Import hatası",
    notificationFailed: "Bildirim gönderilemedi",
    bulkDeleteError: "Toplu silme hatası",
    errorOccurred: "Bir hata oluştu",
    selectFirm: "Firma seçin",
    platePlaceholder: "Örn: 1-ABC-123",
    brandPlaceholder: "Örn: Ford",
    modelPlaceholder: "Örn: Transit",
    yearPlaceholder: "Örn: 2023",
    selectColor: "Renk seçin",
    vehicleDetailsSection: "Araç Detayları",
    chassisPlaceholder: "Şasi numarası",
    loadPlaceholder: "Örn: 1162 KG",
    fuelSelectLabel: "Yakıt tipi",
    permitPlaceholder: "İzin numarası",
    ownershipPlaceholder: "Sahiplik tipi",
    purchasePlaceholder: "Satın alma yeri",
    insuranceCompanyLabel: "Sigorta şirketi",
    maintenanceTracking: "Bakım ve Sigorta Takibi",
    insuranceExpiryDate: "Sigorta Bitiş Tarihi",
    inspectionExpiryDate: "Muayene Bitiş Tarihi",
    lastMaintenanceDate: "Son Bakım Tarihi",
    nextMaintenanceDate: "Sonraki Bakım Tarihi",
    lastMaintenanceKmLabel: "Son Bakım KM",
    nextMaintenanceKmLabel: "Sonraki Bakım KM",
    notesLabel: "Notlar",
    notesPlaceholder: "Ek bilgiler...",
    selectOption: "Seçin",
    maintenanceKmPlaceholder: "Örn: 50000",
    nextMaintenanceKmPlaceholder: "Örn: 60000",
    ruhsatInVehicle: "Araç içinde",
    ruhsatOutVehicle: "Araç dışında",
    tableStatus: "Durum",
    tablePlate: "Plaka",
    tableBrandModel: "Marka / Model",
    tableYear: "Yıl",
    tableFuel: "Yakıt",
    tableOwnership: "Sahiplik",
    tableInsurance: "Sigorta",
    tableInspection: "Muayene",
    tableNextMaintenance: "Sonraki Bakım",
    tableFirm: "Firma",
    documentsTitle: "Belgeler",
    vehicleDetailTitle: "Araç Detayı",
    deleteVehicleTitle: "Aracı Sil",
    deleteVehicleConfirm: "plakalı aracı silmek istediğinize emin misiniz?",
    bulkDeleteTitle: "Toplu Araç Silme",
    bulkDeleteMessage: "araç silinecek. Bu işlem geri alınamaz.",
    deleteCountBtn: "Aracı Sil",
    buildYear: "Bouwjaar (Yıl)",
    showSold: "Satılanları göster",
    resetFilters: "Sıfırla",
    vehicleLoadError: "Araç yüklenemedi",
    saved: "Kaydedildi",
    saveError: "Kaydetme hatası",
    docUploaded: "{{count}} belge yüklendi",
    uploadError: "Yükleme hatası",
    docDeleted: "Belge silindi",
    updateError: "Güncelleme hatası",
    photoUploaded: "{{count}} fotoğraf yüklendi",
    photoDeleted: "Fotoğraf silindi",
    previewError: "Önizleme yüklenemedi",
    pdfLoadError: "PDF yüklenemedi",
    loadingPreview: "Yükleniyor...",
    sold: "SATILDI",
    ownershipType: "Lease / Eigendom",
    // Filters
    filterBtn: "Filtrele",
    filterTitle: "Gelişmiş Filtreler",
    allFirms: "Tüm Firmalar",
    allFuel: "Tüm Yakıt Tipleri",
    allStatus: "Tüm Durumlar",
    vergunningFilter: "Vergunning",
    vergunningAll: "Tümü",
    vergunningYes: "Vergunning Var",
    vergunningNo: "Vergunning Yok",
    tireFilter: "Lastik (Band)",
    tireAll: "Tümü",
    tireHas: "Lastik Var",
    tireNone: "Lastik Yok",
    tireSummer: "Yazlık",
    tireWinter: "Kışlık",
    tireAllSeason: "Yazlık-Kışlık",
    includeSold: "Satılanları dahil et",
    clearAllFilters: "Tüm Filtreleri Temizle",
    applyFilters: "Uygula",
    activeFilters: "Aktif Filtre",
    brandIcons: "Marka İkonları",
    brandIconsTitle: "Marka İkonları Yönetimi",
    brandIconUpload: "Yeni İkon Yükle",
    brandName: "Marka Adı",
    uploadedIcons: "Yüklü İkonlar",
    noIconsYet: "Henüz ikon yüklenmedi",
    replaceIcon: "Değiştir",
    maxOneDoc: "Maks. 1 belge",
    fileMissing: "Dosya bulunamadı",
    columns: "Sütunlar",
    visibleColumns: "Görünür Sütunlar",
    showAll: "Tümünü Göster",
  },
  dailyStatus: {
    title: "Çalışan Durumu",
    description: "Çalışanların günlük durumlarını takip edin",
    today: "Bugün",
    status: "Durum",
    selectStatus: "Durum Seç",
    legend: "Durum Açıklamaları",
    noUsers: "Kullanıcı bulunamadı",
    updatedBy: "Güncelleyen",
    working: "Çalıştı",
    halfDay: "Yarım Gün",
    sick: "Hasta",
    dop: "DOP",
    onLeave: "İzinli",
    paternity: "Babalık İzni",
    notSet: "Belirsiz",
    cancel: "İptal",
    goToPage: "Tüm Durumları Gör",
    clickToApplyAll: "Toplu değiştirmek için tıklayın",
    setAllTo: "Tümünü {status} olarak ayarla",
    clearAllStatuses: "Tüm durumları temizle",
    updatingAll: "Tüm kullanıcılar güncelleniyor...",
    bulkUpdateTitle: "Toplu Durum Değişikliği",
    bulkUpdateConfirm: "Tüm çalışanların durumunu \"{status}\" olarak değiştirmek istediğinizden emin misiniz?",
    usersWillBeUpdated: "kullanıcı güncellenecek",
    filteredUsers: "Arama filtresi uygulandı",
    applyToAll: "Tümüne Uygula",
    bulkUpdateSuccess: "{count} kullanıcının durumu güncellendi",
    bulkUpdateError: "{count} kullanıcı güncellenemedi",
    allUsersAlreadyHaveStatus: "Tüm kullanıcılar zaten bu durumda",
    pendingChanges: "değişiklik",
    statusUpdated: "Durum güncellendi",
    employeesUpdated: "çalışan güncellendi",
    noChanges: "Değişiklik yok",
    changesSaved: "Değişiklikler kaydedildi",
    selectedEmployees: "seçili çalışan",
    allEmployees: "tüm çalışanlar",
    bulkWarning: "Tüm çalışanlar için durum güncellenecek",
    daySummary: "Gün Özeti",
    showEmployees: "Çalışanları Göster",
    hideEmployees: "Çalışanları Gizle",
    quickEditMode: "Hızlı İşaretleme Modu",
    quickEditActive: "seçili - Hücrelere tıklayarak hızlıca işaretleyin",
    clickAgainToClear: "Tekrar tıklayınca temizler",
    clickStatusToActivate: "Hızlı işaretleme için bir durum seçin",
    tapCellToApply: "Hücreye dokunun",
    clickCellToApply: "Durum uygulamak için hücreye tıklayın • Tekrar tıklayınca temizler",
    switchTo: "Değiştir:",
    exitQuickEdit: "Çıkış",
    cannotEditPastDates: "Geçmiş tarihleri düzenleme yetkiniz yok",
    pastDateWarning: "Geçmiş Tarih Uyarısı",
    pastDateConfirmMessage: "Geçmiş bir tarihteki çalışan durumunu değiştirmek üzeresiniz. Bu işlem kayıtları etkileyecektir.",
    pastDateConfirmNote: "Bu önemli bir işlem olduğundan, devam etmek istediğinizden emin olun.",
    confirmPastEdit: "Evet, Düzenle",
    overwriteConfirmTitle: "Mevcut Durum Değiştirilecek",
    overwriteConfirmDesc: "Bu hücrede zaten bir durum var. Değiştirmek istiyor musunuz?",
    currentStatus: "Mevcut Durum",
    newStatus: "Yeni Durum",
    confirmOverwrite: "Evet, Değiştir",
    allUsersHaveStatus: "Tüm kullanıcıların zaten bir durumu var",
    skippedExisting: "mevcut durum atlandı",
    willBeUpdated: "Güncellenecek",
    willBeSkipped: "Atlanacak",
    existingStatusesProtected: "Mevcut durumlar korunacak",
    externalFirm: "Diğer Firma",
    selectExternalFirm: "Firma seçin...",
    willShowAs: "Gösterim:",
    syncLeaves: "İzinleri Senkronize Et",
    syncLeavesTitle: "İzin Senkronizasyonu",
    syncLeavesDesc: "Onaylı izin taleplerini çalışma durumuna aktar",
    syncEmployees: "çalışanın",
    syncMissingDays: "eksik günü bulundu",
    missingDayCount: "eksik gün",
    syncUser: "Senkronize Et",
    syncAll: "Tümünü Senkronize Et",
    allSynced: "Tüm izinler senkronize!",
    noMissingDays: "Eksik gün bulunamadı.",
    day: "gün",
    noPastEditPermission: "Geçmiş tarih düzenleme yetkiniz yok",
    pastDateConfirmTitle: "Geçmiş Tarih Düzenleme",
    showOnlyWorking: "Sadece Çalışanlar",
    todayShort: "Bugün",
    weekViewLabel: "Hafta",
  },
  leaveRequestsAdmin: {
    addForUser: "Kullanıcıya İzin Ekle",
    addForUserDesc: "Bir kullanıcı adına izin talebi oluşturun",
    autoApprove: "Otomatik Onayla",
    autoApproveDesc: "İzin talebi hemen onaylanır ve bakiyeden düşülür",
    createAndApprove: "Oluştur ve Onayla",
    createdAndApproved: "İzin talebi oluşturuldu ve onaylandı",
    created: "İzin talebi oluşturuldu",
    fillRequired: "Lütfen tüm zorunlu alanları doldurun",
    selectUser: "Kullanıcı Seç",
    create: "Oluştur",
  },
  myFinance: {
    title: "Finansal Verilerim",
    subtitle: "Avans, POT, laadvergoeding ve diğer kayıtlarınız",
    hiddenTitle: "Finansal veriler şu an gizli",
    hiddenDesc: "Firma yöneticiniz çalışan finansal verilerinin görüntülenmesini kapatmış. Sorularınız için yöneticinizle iletişime geçin.",
    savePdf: "PDF Olarak İndir",
  },
  workStats: {
    myStatistics: "Çalışma Durumum",
    myStatisticsDesc: "Yıllık çalışma durumu özeti",
    adminStatistics: "Çalışma İstatistikleri",
    employeeStatistics: "Çalışan İstatistikleri",
    adminStatisticsDesc: "Tüm çalışanların durum istatistikleri",
    monthlyBreakdown: "Aylık Dağılım",
    statusDistribution: "Durum Dağılımı",
    calendarView: "Takvim Görünümü",
    employeeBreakdown: "Çalışan Bazlı Dağılım",
    yearSummary: "Yıl Özeti",
    periodSummary: "Dönem Özeti",
    totalRecords: "yılında toplam",
    daysRecorded: "gün kaydedildi",
    periodTotal: "döneminde toplam",
    recordsFound: "kayıt bulundu",
    employeesTracked: "çalışan takip edildi",
    quickRange: "Hızlı Seçim",
    today: "Bugün",
    yesterday: "Dün",
    thisWeek: "Bu Hafta",
    lastWeek: "Geçen Hafta",
    lastMonth: "Geçen Ay",
    thisMonth: "Bu Ay",
    thisQuarter: "Bu Çeyrek",
    dateRange: "Tarih Aralığı",
    year: "Yıl",
    thisYear: "Bu Yıl",
    startDate: "Başlangıç",
    endDate: "Bitiş",
    exportExcel: "Excel İndir",
    exportSuccess: "Excel dosyası indirildi",
    externalFirm: "Diğer Firma",
  },
  lockScreen: {
    sessionLocked: "Oturum Kilitli",
    sessionLockedDesc: "Oturum kilitlendi",
    unlockSession: "Oturum kilidi açıldı",
    passwordPlaceholder: "Şifrenizi girin...",
    authPlaceholder: "Kimlik doğrulama...",
    wrongPassword: "Şifre hatalı",
    unlock: "Kilidi Aç",
    or: "veya",
    logout: "Oturumu Kapat",
    lockScreen: "Ekranı Kilitle",
    inactivityMessage: "{{minutes}} dakika hareketsizlik nedeniyle kilitlendi",
    inactivityShort: "{{minutes}} dk hareketsizlik",
    biometricUnlock: "Biyometrik ile Aç",
    biometricFailed: "Biyometrik doğrulama başarısız",
    biometricSuggestion: "Parmak izi veya yüz tanıma ile hızlı kilit açma için profil sayfanızdan biyometrik kaydı yapabilirsiniz.",
    biometricSecurity: "Biyometrik Güvenlik",
    biometricDescription: "Parmak izi veya yüz tanıma ile kilit ekranını hızlıca açabilirsiniz.",
    biometricRegistered: "Biyometrik kayıt başarılı!",
    biometricCancelled: "Biyometrik kayıt iptal edildi",
    biometricDeleted: "Biyometrik kayıt silindi",
    registerBiometric: "Biyometrik Kaydet",
    addAnotherDevice: "Başka Cihaz Ekle",
    registeredDevices: "kayıtlı cihaz",
    lastUsed: "Son kullanım",
    registered: "Kayıt",
    dismiss: "Kapat",
    idleTimeout: "Oturum Kilitleme Süresi",
    idleTimeoutDesc: "Hareketsizlik sonrası ekran otomatik kilitlenir",
  },
  settings: {
    securitySettings: "Güvenlik Ayarları",
    lockScreenSettings: "Oturum kilitleme ve güvenlik ayarları",
    minutes: "dakika",
    idleTimeoutDescription: "Kullanıcı belirtilen süre boyunca hareketsiz kalırsa ekran otomatik olarak kilitlenir. (1-120 dakika)",
  },
  email: {
    mandrill_api_key: "Mandrill API Anahtarı",
    smtp_pass: "SMTP Şifre",
  },
  sms: {
    api_key: "SMS API Anahtarı",
  },
  whatsapp: {
    api_key: "WhatsApp API Anahtarı",
  },
  planning: {
    days: {
      0: "Pazartesi", 1: "Salı", 2: "Çarşamba", 3: "Perşembe",
      4: "Cuma", 5: "Cumartesi", 6: "Pazar"
    },
    copyDayToNext: "{{day}} → {{next}} gününe kopyala",
    spreadDayTitle: "{{day}} gününü kalan {{remaining}} hafta içi güne yay (Pazar hariç)",
    prevWeek: "Önceki hafta",
    nextWeek: "Sonraki hafta",
    copyFromPrevWeek: "Önceki haftadan kopyala",
    depotAndRoutes: "Depo & Rota",
    deleteWeekTitle: "Bu haftadaki tüm atamaları sil",
    firmDepotRoute: "Firma / Depo / Rota",
    viewConflicts: "Çakışmaları görüntüle",
    boardCanvas: {
      title: "Planning Board",
      zoomIn: "Yakınlaştır",
      zoomOut: "Uzaklaştır",
      fitAll: "Tümünü sığdır",
      preparing: "Hazırlanıyor…",
      assignmentsCount: "{{count}} atama",
      downloadExcelTitle: "Renkli Excel olarak indir",
      open: "Aç",
      noAssignmentsWeek: "Bu haftada atama yok",
      moreFirms: "+{{count}} firma daha — \"Aç\" ile detay",
      dayCol: "Gün",
      depot: "DEPO",
      excelDownloaded: "W{{week}} renkli Excel indirildi",
      downloadFailed: "İndirme başarısız",
      dataLoadFailed: "Veri yüklenemedi",
      legend: { depot: "DEPO", assignment: "Atama", driver: "Şoför", day: "Gün" },
      legendToggle: "Açıklama"
    }
  },
  mailArchive: {
    description: "Mail Arşiv Kuralları tarafından otomatik alınan ekler burada listelenir. PostNL dağıtım listeleri için ayrı sayfayı kullanın.",
    searchPlaceholder: "Dosya / konu / gönderen ara...",
    allRules: "Tüm Kurallar",
    allFirms: "Tüm Firmalar",
    allYears: "Tüm Yıllar",
    noRecords: "Arşivlenmiş dosya bulunamadı."
  },
  dpd: {
    common: {
      firm: "Firma", date: "Tarih", dateFrom: "Başlangıç", dateTo: "Bitiş",
      refresh: "Yenile", loading: "Yükleniyor...", noData: "Veri yok",
      total: "Toplam", search: "Ara...", clear: "Temizle", cancel: "İptal",
      delete: "Sil", preview: "Önizle", page: "Sayfa", pageSize: "Sayfa boyutu",
      first: "İlk", last: "Son", prev: "Önceki", next: "Sonraki",
      preset7: "Son 7 gün", preset14: "Son 14 gün", preset30: "Son 30 gün",
      preset90: "Son 90 gün", preset3: "Son 3 gün",
      day: "gün", tour: "Tur", courier: "Kurye", subco: "Subco",
      packages: "Paket", stops: "Stops", km: "Km", hours: "Saat",
      retour: "Retour", deliveryRate: "Teslim Oranı", successRate: "Başarı %",
      fastTrans: "Fast-Trans", ownCompany: "Kendi Firmanız", activeDays: "Aktif Gün"
    },
    dailySummary: {
      title: "DPD Günlük Özet", subtitle: "Fast-Trans DPD turları — kurye, stops, paket ve kilometre bilgisi",
      ingestFromMail: "Mail Arşivinden Aktar",
      cols: { tour: "Tur", courier: "Kurye", chassis: "Plaka/Şasi", stops: "Stops", parcels: "Paket", retourPlan: "Retour Plan", km: "Km", duration: "Süre", start: "Başlangıç", end: "Bitiş", endpoint: "Endpoint" },
      stats: { tours: "Tur", totalStops: "Toplam Stops", delivered: "Teslim Edilen", totalKm: "Toplam Km", retour: "Retour" }
    },
    driverPerformance: {
      title: "DPD Şoför & Tur Performansı",
      subtitle: "Tarih aralığında {{group}} bazlı toplam paket, teslim oranı, retour ve mesafe.",
      groupCourier: "Kurye Bazında", groupTour: "Tur Bazında",
      trendTitle: "Haftalık Trend (Son 8 Hafta)",
      cols: { courier: "Kurye", tour: "Tur", days: "Gün", tours: "Turlar", couriers: "Kuryeler", parcels: "Paket", stops: "Stops", retour: "Retour", deliveryPct: "Teslim %", km: "Km", hours: "Saat", avgKmDay: "Ort. Km/Gün" },
      colorLegend: "Renk kodları:",
      empty: "Seçili tarih aralığı için veri bulunamadı."
    },
    consolidated: {
      title: "DPD Konsolide Günlük Operasyon Raporu",
      subtitle: "Fast-Trans için günlük konsolide performans: hat başarı oranı, retour kök nedenleri ve otomatik yönetim değerlendirmesi.",
      modeSingle: "Tek Gün", modeRange: "Tarih Aralığı",
      kpi: {
        parcelsPlan: "Dağıtıma Çıkan Koli", tourSum: "{{count}} Hat Toplamı", tourSumRange: "{{tours}} Hat × {{days}} gün",
        deliveredSA13: "Başarılı Teslimat (SA13)", deliveryRatio: "Teslim Oranı: %{{rate}}",
        returnedSA23: "Teslim Edilemeyen (SA23)", returnRate: "İade Oranı: %{{rate}}",
        pickupSA15: "Toplanan Paket (SA15)", pickupSubtitle: "Kuryelerin Aldığı Pickup",
        ftRetour: "Fast Trans Retour", scannedOthers: "Depoya Taranan ({{others}} diğer)",
        totalKm: "Toplam Kilometre", kmPerParcel: "Ort. {{v}} km/koli",
        totalHours: "Toplam Çalışma Süresi", hoursPerTour: "Ort. {{v}} sa/hat",
        activeLines: "Aktif Hat", activeLinesSubtitle: "Fast-Trans"
      },
      tourTableTitle: "Fast Trans — Hat & Sürücü Gün Sonu Kapanış Performansı",
      tourCols: { date: "Tarih", line: "Hat", driverChassis: "Sürücü & Şasi", plan: "Plan", sa13: "SA13", sa23: "SA23", sa15: "SA15", distance: "Mesafe", durationOFD: "Süre (OFD)", parcelsPerHour: "Koli/Saat", endpoint: "Endpoint", successPct: "Başarı %" },
      reasonBreakdown: "Retour Sebep Kodu Dağılımı (Fast Trans)",
      reasonCols: { code: "Kod", label: "Açıklama", count: "Adet", pct: "%", chart: "Dağılım" },
      retourDetayTitle: "Retour Detay: Kişi, Adres ve Neden Bazında",
      retourDetayHeader: "({{ft}} Fast-Trans paketi{{othersText}})",
      retourOthersText: " · {{n}} diğer subco",
      retourCols: { packageNo: "Paket No", firm: "Firma", line: "Hat", recipient: "Alıcı & Adres", postcode: "Posta", weight: "Kg", reason: "İade Kök Nedeni", time: "Saat" },
      insightsTitle: "Otomatik Yönetim Değerlendirmesi & Aksiyonlar",
      shownRange: "Gösterilen: {{from}} - {{to}} / {{total}}",
      noTourData: "Bu tarih için tur verisi yok."
    },
    monthlyInvoice: {
      title: "DPD Aylık Fatura Özeti",
      subtitle: "Fast-Trans için Subco Details dosyalarından tur bazlı aylık paket, ürün kodu ve prim özet tablosu.",
      month: "Ay",
      kpi: { totalParcels: "Toplam Paket", reliability: "Ort. Güvenilirlik", basePay: "Basisvergoeding", netPay: "Net Ödeme",
             daysAndTours: "{{days}} gün / {{tours}} tur", bonusMalus: "Bonus {{bonus}} / Malus {{malus}}", netSubtitle: "Base + Bonus − Malus" },
      breakdownTitle: "Tur Bazlı Aylık Dağılım", productTitle: "Ürün Kodu Bazlı Dağılım (Aylık Toplam)",
      productHint: "Kodlar: 03D=Standart teslimat, 03XD=Extra, 03SD=Saturday, 04DAD/04DAV=Weekend, 05MAST=Master, vs.",
      cols: { tour: "Tur", activeDays: "Aktif Gün", delivered: "Teslim Paket", stops: "Stops", pickup: "Pickup", km: "Km", reliabilityPct: "Güv. %", basePay: "Base (€)", bonus: "Bonus", malus: "Malus", netPay: "Net (€)", totalRow: "Toplam" },
      empty: "Bu ay için fatura verisi yok. Subco Details Excel'leri e-postadan gelmiş olmalı.",
      sourceFiles: "Kaynak: {{files}}"
    },
    heatmap: {
      title: "DPD Retour Isı Haritası",
      subtitle: "Posta kodu (ilk 2 hane) × iade sebep kodu matrisi. Sorunlu bölgeleri ve kök nedenleri görselleştirir.",
      subcoFilter: "Subco (opsiyonel örn: fast)", ftOnly: "Sadece Fast-Trans", clearFilter: "Filtreyi Kaldır",
      stats: { totalRetour: "Toplam İade", pcRegion: "PC Bölgesi", reasonCodes: "Farklı Sebep Kodu" },
      cols: { pcRegion: "PC / Bölge", total: "Toplam" },
      legendLow: "Düşük → Yüksek", legendMax: "Max: {{n}} paket / hücre", legendDensity: "Yoğunluk:",
      reasonLegendTitle: "Sebep Kodu Açıklamaları",
      empty: "Seçili filtreler için iade verisi bulunamadı."
    },
    subcoComparison: {
      title: "DPD Subco Karşılaştırma",
      subtitle: "Fast-Trans ile diğer subco'ların retour hacmi ve kök nedenlerini karşılaştırır. Retour verisi tüm subco'ları içerir; teslim & km verisi sadece Fast-Trans için mevcuttur.",
      ftBlockTitle: "Fast-Trans (Kendi Firmanız) — {{days}} gün",
      metrics: { delivered: "Teslim Paket", retour: "Retour", success: "Başarı Oranı", totalKm: "Toplam Km" },
      stats: { totalRetour: "Toplam İade", activeSubco: "Aktif Subco", activeDays: "Aktif Gün" },
      trendTitle: "Haftalık Retour Trendi — Top 6 Subco",
      cols: { subco: "Subco", retour: "Retour", share: "Pay %", chart: "Grafik", tours: "Turlar", activeDays: "Aktif Gün", avgDay: "Ort/Gün", weight: "Ağırlık (kg)" },
      rootCauses: "Top İade Kök Nedenleri:",
      empty: "Seçili tarih aralığında iade verisi bulunamadı.",
      hint: "Bir satıra tıklayarak o subco'nun en yaygın iade sebep kodlarını görebilirsiniz."
    },
    retourReport: {
      title: "DPD Retour Raporu",
      subtitle: "Teslim edilemeyen paketler — sunucu tarafı sayfalama + gelişmiş filtreler",
      filters: { tour: "Tur (Q10)", subco: "Subco", reason: "Sebep Kodu (25)", pc: "Posta Kodu (35)", q: "Paket/Alıcı ara..." },
      totalPackages: "{{count}} paket", filtered: "(filtreli)", clearAll: "Filtreleri Temizle",
      aggTitle: "{{title}} Başına ({{count}})",
      cols: { packageNo: "Paket No", tour: "Tur", time: "Saat", reason: "Sebep", weight: "Kg", pc: "Posta", recipient: "Alıcı", subco: "Subco" },
      shownRange: "Gösterilen: {{from}} - {{to}} / {{total}}",
      empty: "Filtrelere uyan retour kaydı yok."
    },
    courierMapping: {
      title: "DPD Kurye Eşleştirme",
      subtitle: "DPD RouteDataLog dosyasındaki kurye adlarını gerçek HR çalışan kayıtlarına bağlayın. Fuzzy önerileri kabul edebilir veya manuel seçim yapabilirsiniz.",
      autoMinLabel: "Otomatik eşleştirme skoru ≥", autoApply: "Otomatik Uygula",
      stats: { total: "Toplam Kurye", mapped: "Eşleşen", unmapped: "Eşleşmeyen" },
      cols: { courier: "DPD Kurye Adı", status: "Durum", match: "Eşleşen Çalışan / Fuzzy Öneriler", manual: "Manuel Seçim", action: "İşlem" },
      statusMapped: "Eşleşti", statusUnmapped: "Yok",
      noSuggestion: "Uygun öneri yok — manuel seçim yapın",
      pickEmployee: "Çalışan seç...", searchPlaceholder: "İsim veya e-posta ara...",
      noEmployee: "Çalışan bulunamadı.",
      remove: "Kaldır", empty: "DPD RouteDataLog'da kurye bulunamadı.",
      hint: "💡 Fuzzy skor: 100 = ad + soyad tam eşleşme, 50 = sadece bir isim eşleşti. Otomatik uygula {{score}}+ olanları kaydeder."
    },
    fileCategories: {
      title: "DPD Dosya Kategorileri",
      subtitle: "Mail arşivindeki DPD eklerini tip bazında görüntüle & tek tıkla / kategori bazında içe aktar. Aynı dosya tekrar geldiğinde otomatik atlanır; junk dosyalar (image, signature) filtrelenir.",
      ingestAll: "Tümünü İçe Aktar", ingestCat: "Bu Kategoriyi Aktar", deleteAll: "Tümünü Sil",
      resetAll: "Tüm Rapor ve Analizleri Sıfırla", resetCat: "Bu Kategoriyi Sıfırla",
      resetAllTitle: "Tüm DPD verilerini sıfırlamak istediğinize emin misiniz?",
      resetAllBody: "Tüm rapor ve analiz verileri silinecek (mail arşivi korunacak). Bundan sonra 'Tümünü İçe Aktar' ile Excel'ler baştan tekrar okunabilir.",
      resetCatTitle: "{{cat}} kategorisini sıfırla?",
      resetCatBody: "Bu kategoriye ait tüm parse edilmiş satırlar ve ingest log kayıtları silinecek. Mail arşivi korunur; yeniden içe aktarabilirsiniz.",
      resetDone: "Sıfırlandı: {{n}} kayıt silindi",
      resetFailed: "Sıfırlama başarısız",
      mailDate: "Mail Tarihi",
      totalSummary: "Toplam {{files}} dosya, {{cats}} kategori",
      countFiles: "{{n}} dosya", countIngested: "({{n}} içe aktarılmış)",
      cols: { file: "Dosya", date: "Tarih", mailDate: "Mail Tarihi", archived: "Arşivleme", from: "Gönderen", status: "Durum", action: "İşlem" },
      excludePlaceholder: "Dosya adında hariç tut (ör: HYK, test)",
      filteredHint: "{{n}} dosya filtrelendi",
      sort: {
        mailDesc: "Mail Tarihi (Yeni → Eski)",
        mailAsc: "Mail Tarihi (Eski → Yeni)",
        arcDesc: "Arşivleme (Yeni → Eski)",
        arcAsc: "Arşivleme (Eski → Yeni)",
      },
      status: { rows: "{{n}} satır", waiting: "Bekliyor", junk: "Junk" },
      toast: {
        alreadyIngested: "Zaten içe aktarılmış",
        importedRows: "{{n}} satır aktarıldı",
        importFailed: "Aktarma başarısız",
        bulkResult: "{{ingested}} dosya işlendi",
        bulkAlready: "{{n}} zaten aktarılmış", bulkJunk: "{{n}} junk atlandı", bulkUnknown: "{{n}} tanınmayan atlandı", bulkErrors: "{{n}} hata",
        bulkFailed: "Toplu aktarma başarısız",
        previewFailed: "Önizleme yüklenemedi",
        deleted: "Dosya silindi", deleteFailed: "Silinemedi",
        junkDeleted: "{{done}} junk dosya silindi"
      },
      dialog: {
        deleteFileTitle: "Dosyayı sil?",
        deleteFileBody: "{{filename}} kalıcı olarak silinecek. Bu işlem geri alınamaz.",
        deleteJunkTitle: "{{n}} junk dosyayı silmek istediğine emin misin?",
        deleteJunkBody: "Bu işlem geri alınamaz. Mail arşivi ve S3'ten kalıcı olarak silinecek."
      },
      emptyState: "Mail arşivinde henüz DPD dosyası bulunamadı.",
      emptyHint: "Ayarlar → Mail Arşiv Kuralları'nda dpd.be için bir kural tanımlayın."
    },
    alerts: {
      widgetTitle: "DPD Uyarıları",
      severityHigh: "yüksek", severityMedium: "orta", severityLow: "düşük",
      badges: { high: "Yüksek", medium: "Orta", low: "Düşük" },
      types: { lowDelivery: "Düşük Teslim", highRetour: "Yüksek Retour" },
      detailLink: "Detay →",
      moreAlerts: "+{{n}} daha çok uyarı — "
    },
    analytics: {
      title: "DPD Analitik & İçgörü",
      subtitle: "Fast-Trans özel — yıllık trend, karşılaştırma, öngörü ve AI özet",
      year: "Yıl",
      refresh: "Yenile",
      loading: "Analitik hesaplanıyor…",
      empty: "Bu yıl için Fast-Trans verisi yok. Excel dosyalarını içe aktarın.",
      kpi: {
        packages: "Toplam Paket",
        retour: "Toplam Retour",
        deliveryRate: "Teslim Başarısı",
        activeDays: "Aktif Gün",
        activeCouriers: "Aktif Şoför",
        activeTours: "Aktif Tur",
        avgDaily: "Günlük Ortalama",
      },
      yoy: {
        title: "Yıl Karşılaştırması ({{prev}} vs {{cur}})",
        packages: "Paket Hacmi",
        retour: "Retour Sayısı",
        deliveryRate: "Teslim Başarısı",
        couriers: "Aktif Şoför",
      },
      monthly: {
        title: "Aylık Trend",
        subtitle: "Son 24 ay teslim / retour hacmi",
        packages: "Paket",
        retour: "Retour",
        deliveryPct: "Teslim %",
      },
      dow: {
        title: "Haftanın Günü Örüntüsü",
        subtitle: "Hangi günler kritik — hacim & başarı oranı",
      },
      reasons: {
        title: "Retour Sebep Trendi",
        topTitle: "En Sık Retour Sebepleri",
        share: "Pay",
      },
      drivers: {
        title: "Şoför Sıralaması & Tavsiyeler",
        subtitle: "Skor = 60% teslim + 30% hacim + 10% süreklilik",
        rank: "Sıra",
        courier: "Şoför",
        score: "Skor",
        packages: "Paket",
        retour: "Retour",
        deliveryPct: "Teslim %",
        days: "Gün",
        recommendation: "Öneri",
      },
      forecast: {
        title: "Ön-görü",
        nextMonthRetour: "Önümüzdeki Ay Retour Tahmini",
        nextMonthPackages: "Beklenen Paket Hacmi",
        based: "Son {{n}} aya göre",
        trend: { up: "Yükseliş", down: "Düşüş", flat: "Sabit" },
      },
      insights: {
        title: "Otomatik İçgörüler",
        subtitle: "Rakamlardan çıkarılan örüntüler",
      },
      ai: {
        title: "Analiz (Claude Sonnet)",
        subtitle: "Yönetici brifingi — verilerin doğal dil değerlendirmesi",
        loading: "Analiz oluşturuluyor…",
        error: "Analiz üretilemedi",
      },
      pdf: {
        export: "PDF İndir",
        generating: "PDF oluşturuluyor…",
        done: "PDF hazır",
        failed: "PDF oluşturulamadı",
        fileName: "DPD-Analitik-{{year}}.pdf",
      },
      driver: {
        modalTitle: "Şoför Detayı — {{name}}",
        coaching: "Kişisel Koçluk Notu",
        vsAvg: "Firma ortalamasına göre",
        rank: "Sıralama",
        personalTrend: "Kişisel Aylık Trend",
        yourReasons: "Sana Özel Retour Sebepleri",
        close: "Kapat",
        clickHint: "Detay için satıra tıklayın",
      },
    }
  }
};

export default tr;
